<!-- 合作伙伴主数据查看/编辑 -->
<template>
  <div class="editCooperation main-content">
    <!-- 按钮 -->
    <!-- <div class="btns" v-if="fromFlag">
      <el-button type="primary" @click="sureOpenReject('1')" v-if="isApproval">批准</el-button>
      <el-button type="primary" @click="sureOpenReject('0')" v-if="isReject">驳回</el-button>
    </div> -->
    <!-- <div class="btn">
    </div> -->
    <!-- 顶部表单 -->
    <!-- <div class="topData">
      <el-form :model="topData" :rules="rules" ref="topData" label-width="100px">
        <el-row :gutter="10">
          <!== 公司code ==>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyCode')" prop="companyCode">
              <el-input
                :placeholder="$t('cooperation.placeholder.companyCode')"
                disabled
                v-model="topData.companyCode"
              ></el-input>
            </el-form-item>
          </el-col>
          <!== 公司名称 ==>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyName')" prop="companyName">
              <el-input
                :placeholder="$t('cooperation.placeholder.companyName')"
                disabled
                v-model="topData.companyName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!== 业务部门 ==>
            <el-form-item :label="$t('cooperation.label.departmentCode')" prop="departmentName">
              <el-input
                :placeholder="$t('cooperation.placeholder.departmentCode')"
                disabled
                v-model="topData.departmentName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!== 申请时间 ==>
            <el-form-item :label="$t('cooperation.label.requestTime')" prop="requestTime">
              <el-input disabled v-model="topData.requestTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <!== 合作伙伴编码 ==>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.partnerCode')" prop="partnerCode">
              <el-input
                disabled
                v-model="topData.partnerCode"
                :placeholder="$t('cooperation.placeholder.autoProduction')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!== 合作伙伴名称 ==>
          <el-col :span="6">
            <!== 中文名 ==>
            <el-form-item :label="$t('cooperation.label.partnerZhName')" prop="partnerZhName">
              <el-tooltip
                :disabled="!topData.partnerZhName"
                class="item"
                effect="dark"
                :content="String(topData.partnerZhName)"
                placement="top"
              >
                <el-input
                  :disabled="forbidden"
                  :placeholder="$t('cooperation.placeholder.partnerZhName')"
                  v-model="topData.partnerZhName"
                  @change="getPartnerName"
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!== 英文名 ==>
            <el-form-item :label="$t('cooperation.label.partnerEnName')" prop="partnerEnName">
              <el-tooltip
                :disabled="!topData.partnerEnName"
                class="item"
                effect="dark"
                :content="String(topData.partnerEnName)"
                placement="top"
              >
                <el-input
                  :disabled="forbidden"
                  :placeholder="$t('cooperation.placeholder.partnerZhName')"
                  v-model="topData.partnerEnName"
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <!== 创建人 ==>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.createBy')" prop="createBy">
              <el-select disabled clearable v-model="topData.createBy" filterable>
                <el-option
                  v-for="item in requestByList"
                  :key="item.id"
                  :label="item.personName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!== 申请人 ==>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.requestBy')" prop="requestBy">
              <search-table
                v-model="topData.requestBy"
                searchType="personnel"
                :isMultiple="true"
                :currentValue="topData.requestByName || null"
                :checkRowKeys="[topData.requestBy]"
                @input="setRequestPerson"
                :disabled="forbidden"
              ></search-table>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.requestStatus')" prop="requestStatus">
              <el-select
                filterable
                v-model="requestStatus"
                :placeholder="$t('cooperation.placeholder.requestStatus')"
                disabled
              >
                <el-option
                  v-for="item of requestStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!== 审批原因 ==>
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.auditReason')" prop="partnerCode">
              <el-input
                disabled
                v-model="auditReason"
                :placeholder="$t('cooperation.placeholder.auditReason')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div> -->
    <div class="topData">
      <el-form :model="topData" :rules="rules" ref="topData" label-width="140px">
        <el-row :gutter="10">
          <!-- 公司code -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyCode')" prop="companyCode">
              <el-input
                :placeholder="$t('cooperation.placeholder.companyCode')"
                disabled
                v-model="topData.companyCode"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 公司名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.companyName')" prop="companyName">
              <el-input
                :placeholder="$t('cooperation.placeholder.companyName')"
                disabled
                v-model="topData.companyName"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 业务部门 -->
            <el-form-item label="部门名称" prop="departmentCode">
              <!-- <el-select disabled clearable v-model="topData.departmentCode" filterable>
                <el-option
                  v-for="item in departmentList"
                  :key="item.personDepartmentCode"
                  :label="item.personDepartmentName"
                  :value="item.personDepartmentCode"
                >
                </el-option>
              </el-select> -->
              <el-input
                :placeholder="$t('cooperation.placeholder.departmentCode')"
                disabled
                v-model="topData.departmentName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 申请时间 -->
            <el-form-item :label="$t('cooperation.label.requestTime')" prop="requestTime">
              <el-input disabled v-model="topData.requestTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <!-- 合作伙伴编码 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.partnerCode')" prop="partnerCode">
              <el-input
                disabled
                v-model="topData.partnerCode"
                :placeholder="$t('cooperation.placeholder.autoProduction')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 创建人 -->
          <el-col :span="6">
            <el-form-item :label="$t('cooperation.label.createBy')" prop="createBy">
              <el-select disabled clearable v-model="topData.createBy" filterable>
                <el-option
                  v-for="item in requestByList"
                  :key="item.id"
                  :label="item.personName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 业务负责人 -->
          <el-col :span="6">
            <el-form-item label="业务负责人" prop="busnessPersonName">
              <!-- <el-select clearable v-model="topData.requestBy" filterable>
                          <el-option
                            v-for="item in requestByList"
                            :key="item.id"
                            :label="item.personName"
                            :value="item.id">
                          </el-option>
                        </el-select> -->
              <!-- :extraData = "{departmentCodeList: [userInfo.departmentCode]}" -->
              <search-table
                v-model="topData.busnessPersonName"
                searchType="personnel"
                :isMultiple="true"
                :disabled="forbidden"
                :extraData="{ personCompanyCode: this.userInfo.companyCode }"
                :currentValue="topData.busnessPersonName || null"
                :checkRowKeys="[topData.businessPersonNo]"
                @input="setBusinessPerson"
              ></search-table>
            </el-form-item>
          </el-col>
          <!-- 合作伙伴名称 -->
          <!-- 中文名 -->
          <!-- <el-col :span="6">

            <el-form-item :label="$t('cooperation.label.partnerZhName')" prop="partnerZhName">
              <el-tooltip
                :disabled="!topData.partnerZhName"
                class="item"
                effect="dark"
                :content="String(topData.partnerZhName)"
                placement="top"
              >
                <el-input
                  :disabled="forbidden"
                  :placeholder="$t('cooperation.placeholder.partnerZhName')"
                  v-model="topData.partnerZhName"
                  @change="getPartnerName"
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('cooperation.label.partnerEnName')" prop="partnerEnName">
              <el-tooltip
                :disabled="!topData.partnerEnName"
                class="item"
                effect="dark"
                :content="String(topData.partnerEnName)"
                placement="top"
              >
                <el-input
                  :maxlength="64"
                  :disabled="forbidden"
                  :placeholder="$t('cooperation.placeholder.partnerZhName')"
                  v-model="topData.partnerEnName"
                  @change="getPartnerName"
                  clearable
                ></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </div>
    <el-tabs class="editCooperationTabs" type="border-card" v-model="activeNameTab">
      <!-- 基本数据 -->
      <el-tab-pane :label="$t('cooperation.tabsName.baseData')" name="baseData">
        <div class="baseData">
          <!-- <el-form :disabled="forbidden" :model="baseData" :rules="rules" ref="baseData" label-width="105px" > -->
          <!-- 【ID1001597】【BUG】供应商无法扩展成合作伙伴 -->
          <el-collapse v-model="activeNames" class="collapse-main-content">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="collapse-title-pre">
                  <span></span>
                  基本信息
                </div>
              </template>
              <div class="collapse-content">
                <el-form
                  :model="baseData"
                  :rules="rules"
                  ref="baseData"
                  label-width="140px"
                  :disabled="forbidden"
                >
                  <el-row :gutter="10">
                    <!-- 合作伙伴名称 -->
                    <el-col :span="6">
                      <el-tooltip
                        :disabled="!baseData.partnerZhName"
                        class="item"
                        effect="dark"
                        :content="String(baseData.partnerZhName)"
                        placement="top"
                      >
                        <el-form-item label="合作伙伴名称" prop="partnerZhName">
                          <el-input
                            :disabled="forbidden || partnerDetail.requestStatus == 'ZT03'"
                            placeholder="请输入"
                            v-model="baseData.partnerZhName"
                            clearable
                            maxlength="50"
                            @blur="formatPartnerName"
                          ></el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="合作伙伴简称" prop="abbreviation">
                        <el-input
                          :disabled="partnerDetail.requestStatus == 'ZT03'"
                          placeholder="请输入"
                          v-model="baseData.abbreviation"
                          clearable
                          maxlength="50"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- 统一社会信用代码  ps:textOver解决文字超出问题 -->
                    <el-col :span="6">
                      <el-tooltip
                        :disabled="!baseData.creditCode"
                        class="item"
                        effect="dark"
                        :content="String(baseData.creditCode)"
                        placement="top"
                      >
                        <el-form-item :label="$t('cooperation.label.creditCode')" prop="creditCode">
                          <el-input
                            @blur="handleInputHover('creditCode')"
                            :placeholder="$t('cooperation.placeholder.creditCode')"
                            v-model.trim="baseData.creditCode"
                            clearable
                            maxlength="32"
                            :disabled="baseData.ifPersonalPartner == 1"
                          ></el-input>
                        </el-form-item>
                      </el-tooltip>
                    </el-col>
                    <!-- 合作伙伴类型 -->
                    <el-col :span="6">
                      <el-form-item :label="$t('cooperation.label.partnerType')" prop="partnerType">
                        <el-select
                          filterable
                          @change="partnerTypeChange"
                          :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                          v-model="baseData.partnerType"
                          clearable
                        >
                          <el-option
                            v-for="item of partnerTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <!-- 国内合作伙伴 -->
                    <!-- <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.ifDomestic')" prop="ifDomestic">
                  <el-select
                    clearable
                    filterable
                    @change="resolveRules($event, 'ifDomestic')"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.ifDomestic"
                  >
                    <el-option
                      v-for="item of countryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
                    <!-- 个人合作伙伴 -->
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('cooperation.label.ifPersonalPartner')"
                        prop="ifPersonalPartner"
                      >
                        <el-select
                          filterable
                          @change="resolveRules"
                          :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                          v-model="baseData.ifPersonalPartner"
                          clearable
                        >
                          <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                          <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 授信合作伙伴 -->
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('cooperation.label.ifCreditPartner')"
                        prop="ifCreditPartner"
                      >
                        <el-select
                          filterable
                          :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                          v-model="baseData.ifCreditPartner"
                          clearable
                        >
                          <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                          <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 关联合作伙伴 -->
                    <el-col :span="6">
                      <el-form-item label="关联合作伙伴" prop="associatePartner">
                        <search-table
                          v-model="baseData.associatedPartnerName"
                          searchType="partnerParent"
                          :isMultiple="false"
                          :checkRowKeys="curAssoCodes"
                          :currentValue="curAssoListString"
                          :extraData="{ partnerCode: topData.partnerCode }"
                        ></search-table>
                      </el-form-item>
                    </el-col>
                    <!-- 合作伙伴类别 -->
                    <el-col :span="6">
                      <el-form-item :label="$t('cooperation.label.partnerForm')" prop="partnerForm">
                        <el-select
                          filterable
                          v-model="baseData.partnerForm"
                          :placeholder="$t('cooperation.placeholder.partnerForm')"
                          clearable
                        >
                          <el-option
                            v-for="item of partnerFormList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <!-- 法人 -->
                    <el-col :span="6">
                      <el-form-item label="法定代表人" prop="legalPerson">
                        <el-input
                          :placeholder="$t('cooperation.placeholder.legalPerson')"
                          v-model="baseData.legalPerson"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- 法人类型 -->
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('cooperation.label.legalEntityType')"
                        prop="legalEntityType"
                      >
                        <el-select
                          v-model="baseData.legalEntityType"
                          :placeholder="$t('cooperation.placeholder.legalEntityType')"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item of legalList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 身份证号 -->
                    <el-col :span="6">
                      <el-form-item :label="$t('cooperation.label.identityNo')" prop="identityNo">
                        <el-input
                          @blur="handleInputHover('identityNo')"
                          :placeholder="$t('cooperation.placeholder.identityNo')"
                          v-model.trim="baseData.identityNo"
                          :disabled="baseData.ifPersonalPartner != 1"
                          clearable
                          maxlength="50"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('cooperation.label.taxpayerType')"
                        prop="taxpayerType"
                      >
                        <el-select
                          filterable
                          v-model="baseData.taxpayerType"
                          :placeholder="$t('cooperation.placeholder.taxpayerType')"
                          clearable
                        >
                          <el-option
                            v-for="item of taxpayerTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="经营范围" prop="businessScope">
                        <el-tooltip
                          :disabled="!baseData.businessScope"
                          class="item"
                          effect="dark"
                          :content="String(baseData.businessScope)"
                          placement="top"
                        >
                          <el-input
                            placeholder="请输入"
                            v-model="baseData.businessScope"
                            clearable
                            maxlength="1000"
                          ></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="营业执照经营范围" prop="licenseScope">
                        <el-tooltip
                          :disabled="!baseData.licenseScope"
                          class="item"
                          effect="dark"
                          :content="String(baseData.licenseScope)"
                          placement="top"
                        >
                          <el-input
                            placeholder="请输入"
                            v-model="baseData.licenseScope"
                            clearable
                            maxlength="1000"
                          ></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="许可证经营范围" prop="permitScope">
                        <el-tooltip
                          :disabled="!baseData.permitScope"
                          class="item"
                          effect="dark"
                          :content="String(baseData.permitScope)"
                          placement="top"
                        >
                          <el-input
                            placeholder="请输入"
                            v-model="baseData.permitScope"
                            clearable
                            maxlength="1000"
                          ></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </el-col>
                    <!-- 许可证有效期限 -->
                    <el-col :span="6">
                      <el-form-item label="许可证有效期限" prop="licenseValid">
                        <el-date-picker
                          v-model="baseData.licenseValid"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <!-- 成立日期 -->
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('cooperation.label.establishedDate')"
                        prop="establishedDate"
                      >
                        <el-date-picker
                          v-model="baseData.establishedDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :placeholder="$t('cooperation.placeholder.establishedDate')"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="登记机关" prop="registrationAuthority">
                        <el-input
                          placeholder="请输入"
                          v-model="baseData.registrationAuthority"
                          clearable
                          maxlength="64"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <!-- 核准日期 -->
                    <el-col :span="6">
                      <el-form-item label="核准日期" prop="approvalTime">
                        <el-date-picker
                          v-model="baseData.approvalTime"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请输入核准日期"
                          clearable
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <!-- 注册资本 -->
                    <el-col :span="6">
                      <el-row :gutter="10">
                        <el-col :span="16">
                          <el-form-item
                            :label="$t('cooperation.label.registeredAssets')"
                            prop="registeredAssets"
                          >
                            <input-number
                              :max="99999999999.999999"
                              :precision="6"
                              :placeholder="$t('cooperation.placeholder.registeredAssets')"
                              v-model="baseData.registeredAssets"
                              clearable
                            >
                            </input-number>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item class="isShowLabel" prop="currencyType">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="getSelectLabel(baseData.currencyType) + ''"
                              placement="top"
                              :disabled="!baseData.currencyType"
                            >
                              <el-select
                                filterable
                                v-model="baseData.currencyType"
                                :placeholder="$t('cooperation.placeholder.currencyType')"
                                clearable
                              >
                                <el-option
                                  v-for="item of tradeCurrencyList"
                                  :key="item.id"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-tooltip>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <!-- 实缴资本 -->
                    <el-col :span="6">
                      <el-row :gutter="10">
                        <el-col :span="16">
                          <el-form-item label="实缴资本(万)" prop="actualAssets">
                            <input-number
                              :max="99999999999.999999"
                              :precision="6"
                              v-model="baseData.actualAssets"
                              clearable
                            >
                            </input-number>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item class="isShowLabel" prop="currencyType">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="getSelectLabel(baseData.currencyType) + ''"
                              placement="top"
                              :disabled="!baseData.currencyType"
                            >
                              <el-select
                                filterable
                                v-model="baseData.currencyType"
                                :placeholder="$t('cooperation.placeholder.currencyType')"
                                clearable
                              >
                                <el-option
                                  v-for="item of tradeCurrencyList"
                                  :key="item.id"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-tooltip>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="营业期限" prop="businessTerm">
                        <el-input
                          placeholder="请输入"
                          v-model="baseData.businessTerm"
                          clearable
                          maxlength="64"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="6">
                <el-form-item label="实际经营地" prop="invoiceAddress">
                  <el-input
                    placeholder="请输入"
                    v-model="baseData.invoiceAddress"
                    clearable
                    maxlength="64"
                  ></el-input>
                </el-form-item>
              </el-col> -->
                  </el-row>
                  <el-row :gutter="10">
                    <!-- 行业 -->
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('cooperation.label.industryName')"
                        prop="industryName"
                      >
                        <el-select
                          filterable
                          v-model="baseData.industryName"
                          :placeholder="$t('cooperation.placeholder.industryName')"
                          clearable
                        >
                          <el-option
                            style="width: 100%"
                            v-for="item of industryList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 企业类型 -->
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('cooperation.label.enterpriseType')"
                        prop="enterpriseType"
                      >
                        <el-select
                          filterable
                          v-model="baseData.enterpriseType"
                          :placeholder="$t('cooperation.placeholder.enterpriseType')"
                          clearable
                        >
                          <el-option
                            v-for="item of enterpriseTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <!-- 是否为关联方 -->
                    <el-col :span="6">
                      <el-form-item label="是否为关联方（是否为集团客户）" prop="isRelatedParty">
                        <el-select
                          filterable
                          v-model="baseData.isRelatedParty"
                          placeholder="请选择是否为关联方"
                          clearable
                        >
                          <el-option
                            style="width: 100%"
                            v-for="item of yesnoList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 发票类型 -->
                    <el-col :span="6">
                      <el-form-item :label="$t('cooperation.label.taxType')" prop="taxType">
                        <el-select
                          v-model="baseData.taxType"
                          @change="resolveRules"
                          :placeholder="$t('cooperation.placeholder.taxType')"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item of taxTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 交易币种 -->
                    <el-col :span="6">
                      <el-form-item
                        :label="$t('cooperation.label.tradeCurrency')"
                        prop="tradeCurrency"
                      >
                        <el-select
                          filterable
                          v-model="baseData.tradeCurrency"
                          :placeholder="$t('cooperation.placeholder.tradeCurrency')"
                          clearable
                        >
                          <el-option
                            v-for="item of tradeCurrencyList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="activeNames" class="collapse-main-content">
            <el-collapse-item name="2">
              <template slot="title">
                <div class="collapse-title-pre">
                  <span></span>
                  开票信息
                </div>
              </template>
              <div class="collapse-content">
                <el-form
                  :model="baseData"
                  :rules="rules"
                  ref="baseDataRef"
                  label-width="140px"
                  :disabled="forbidden"
                >
                  <el-row :gutter="10">
                    <!-- 开票地址 -->
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('cooperation.label.invoiceAddress')"
                        prop="invoiceAddress"
                      >
                        <el-input
                          :placeholder="$t('cooperation.placeholder.invoiceAddress')"
                          v-model="baseData.invoiceAddress"
                          clearable
                          maxlength="64"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- 开票电话 -->
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('cooperation.label.invoicePhone')"
                        prop="invoicePhone"
                      >
                        <el-input
                          :placeholder="$t('cooperation.placeholder.invoicePhone')"
                          v-model="baseData.invoicePhone"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- 开票银行名称 -->
                    <el-col :span="12">
                      <el-form-item
                        :label="$t('cooperation.label.invoiceBankName')"
                        prop="invoiceBankName"
                      >
                        <el-input
                          :placeholder="$t('cooperation.placeholder.invoiceBankName')"
                          v-model="baseData.invoiceBankName"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- 开票银行账户 -->
                    <el-col :span="12">
                      <el-form-item label="开票银行账户" prop="invoiceBankAccount">
                        <el-input
                          :placeholder="$t('cooperation.placeholder.invoiceBankAccount')"
                          v-model="baseData.invoiceBankAccount"
                          clearable
                          maxlength="32"
                          @input="invoiceBankAccountInput"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- <el-row :gutter="10"> -->
                  <!-- 所属集团 -->
                  <!-- <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.partnerParentCompany')"
                  prop="partnerParentCompanyCode"
                >
                  <search-table
                    v-model="baseData.partnerParentCompanyCode"
                    searchType="partnerParent"
                    :isMultiple="true"
                    :currentValue="baseData.partnerParentCompanyName || null"
                    :checkRowKeys="[baseData.partnerParentCompanyCode]"
                    :extraData="{ partnerCode: topData.partnerCode }"
                    @input="setPartnerParent"
                  ></search-table>
                </el-form-item>
              </el-col> -->
                  <!-- 人员识别号 -->
                  <!-- <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.personnelIdentificationNumber')"
                  prop="personnelIdentificationNumber"
                  :rules="hrRules"
                >
                  <el-input
                    :placeholder="$t('cooperation.placeholder.personnelIdentificationNumber')"
                    v-model="baseData.personnelIdentificationNumber"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col> -->
                  <!-- </el-row> -->
                  <el-row :gutter="10">
                    <!-- 国内合作伙伴 -->
                    <el-col :span="6">
                      <el-form-item label="国家地区" prop="ifDomestic">
                        <el-select
                          @change="resolveRules($event, 'ifDomestic')"
                          :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                          v-model="baseData.ifDomestic"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item of countryList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- 省份/城市 -->
                    <el-col :span="6">
                      <el-row :gutter="10">
                        <el-col :span="16" style="padding-right: 0">
                          <el-form-item label="省市" prop="province">
                            <el-select
                              filterable
                              v-model="baseData.province"
                              @change="handleProvinceChange"
                              :placeholder="$t('cooperation.placeholder.province')"
                              clearable
                            >
                              <el-option
                                v-for="item of provinceList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item class="isShowLabel" prop="city">
                            <el-select
                              filterable
                              v-model="baseData.city"
                              @change="handleCityChange"
                              :placeholder="$t('cooperation.placeholder.city')"
                              clearable
                            >
                              <el-option
                                v-for="item of cityList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <!-- 街道地址/门牌号 -->
                    <el-col :span="12">
                      <el-form-item label="详细地址" prop="streetAddress">
                        <el-input
                          v-model="baseData.streetAddress"
                          placeholder="请输入详细地址"
                          clearable
                          maxlength="32"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.searchCode')" prop="searchCode">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.searchCode')"
                    v-model="baseData.searchCode"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.postCode')" prop="postCode">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.postCode')"
                    v-model="baseData.postCode"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col> -->
                  </el-row>
                  <!-- <el-row :gutter="10" v-if="baseData.partnerType == 'HZHB07'">
              库容限额
              <el-col :span="6">
                <el-row :gutter="10">
                  <el-col :span="16">
                    <el-form-item
                      :label="$t('cooperation.label.capacityLimitAmount')"
                      prop="capacityLimitAmount"
                    >
                      <input-number
                        :max="99999999999.999999"
                        :precision="6"
                        :placeholder="$t('cooperation.placeholder.capacityLimitAmount')"
                        v-model="baseData.capacityLimitAmount"
                        clearable
                      >
                      </input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="capacityLimitCurrencyCode">
                      <el-tooltip
                        :disabled="!baseData.capacityLimitCurrencyName"
                        class="item"
                        effect="dark"
                        :content="String(baseData.capacityLimitCurrencyName)"
                        placement="top"
                      >
                        <el-select
                          filterable
                          v-model="baseData.capacityLimitCurrencyCode"
                          @change="capacityLimitCurrency"
                          :placeholder="$t('cooperation.placeholder.currencyType')"
                          clearable
                        >
                          <el-option
                            v-for="item of tradeCurrencyList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('cooperation.label.mark')" prop="mark">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.mark')"
                    v-model="baseData.mark"
                    clearable
                    maxlength="80"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            申请原因
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('cooperation.label.applyReason')" prop="mark">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.applyReason')"
                    v-model="baseData.applyReason"
                    clearable
                    maxlength="80"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
                  <!-- <template v-if="showDeliverSection">
              <el-row :gutter="10">
                <!==  ==>
                <el-col :span="6">
                  <el-form-item label="投送人姓名" prop="deliverName">
                    <el-input
                      v-model="baseData.deliverName"
                      :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="投送人电话" prop="deliverTelephone">
                    <el-input
                      v-model="baseData.deliverTelephone"
                      :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="投送人身份证号" prop="deliverId">
                    <el-input
                      v-model="baseData.deliverId"
                      :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="7">
                  <el-form-item label="投送人身份证期限" prop="deliverIdExpire">
                    <el-input
                      v-model="baseData.deliverIdExpire"
                      :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5" :pull="1">
                  <el-form-item label="至" prop="deliverIdExpireUntil">
                    <el-input
                      v-model="baseData.deliverIdExpireUntil"
                      :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="投送人地址" prop="deliverAddress">
                    <el-input
                      v-model="baseData.deliverAddress"
                      :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template> -->
                  <DeliverInfo
                    :showDeliverSection="showDeliverSection"
                    :baseData="baseData"
                  ></DeliverInfo>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item :label="$t('cooperation.label.mark')" prop="mark">
                        <el-input
                          :placeholder="$t('cooperation.placeholder.mark')"
                          v-model="baseData.mark"
                          clearable
                          maxlength="80"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-collapse v-model="activeNames" class="collapse-main-content">
            <el-collapse-item name="3">
              <template slot="title">
                <div class="collapse-title-pre">
                  <span></span>
                  银行信息
                </div>
              </template>
              <div class="collapse-content">
                <!-- 银行数据表格 -->
                <div class="tableStyle">
                  <vxe-grid
                    border
                    show-overflow
                    resizable
                    ref="partnersBanks"
                    class="vxe-table-element"
                    size="mini"
                    align="center"
                    :auto-resize="true"
                    :data="baseData.partnersBanks"
                    :columns="bankColumnList"
                    :edit-rules="bankTableEditRules"
                    :toolbar="{}"
                    :edit-config="!forbidden ? { trigger: 'click', mode: 'row' } : {}"
                    :valid-config="{ autoPos: true, message: 'inline' }"
                  >
                    <template v-slot:buttons v-if="!forbidden">
                      <vxe-button
                        @click="$refs.partnersBanks.commitProxy('insert_actived')"
                        type="primary"
                        size="medium"
                        class="vxe-btn-primary"
                        >新增银行</vxe-button
                      >
                      <vxe-button
                        @click="handleDelete('partnersBanks')"
                        type="primary"
                        size="medium"
                        class="vxe-btn-delete"
                      >
                        {{ $t('cooperation.buttons.delete') }}</vxe-button
                      >
                    </template>
                  </vxe-grid>
                </div>
              </div></el-collapse-item
            ></el-collapse
          >
          <!-- 联系人表格 -->
          <el-collapse v-model="activeNames" class="collapse-main-content">
            <el-collapse-item name="4">
              <template slot="title">
                <div class="collapse-title-pre">
                  <span></span>
                  联系信息
                </div>
              </template>
              <div class="collapse-content">
                <div class="tableStyle">
                  <vxe-grid
                    border
                    show-overflow
                    resizable
                    ref="partnersPersons"
                    class="vxe-table-element"
                    size="mini"
                    align="center"
                    :auto-resize="true"
                    :data="baseData.partnersPersons"
                    :columns="linkColumnList"
                    :toolbar="{}"
                    :edit-rules="linkTableEditRules"
                    :edit-config="!forbidden ? { trigger: 'click', mode: 'row' } : {}"
                    :valid-config="{ autoPos: true, message: 'inline' }"
                  >
                    <template v-slot:buttons v-if="!forbidden">
                      <vxe-button
                        @click="$refs.partnersPersons.commitProxy('insert_actived')"
                        type="primary"
                        size="medium"
                        class="vxe-btn-primary"
                        >新增联系人</vxe-button
                      >
                      <vxe-button
                        @click="handleDelete('partnersPersons')"
                        type="primary"
                        size="medium"
                        class="vxe-btn-delete"
                        >{{ $t('cooperation.buttons.delete') }}</vxe-button
                      >
                    </template>
                  </vxe-grid>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <!-- 收货地址表格 -->
          <el-collapse v-model="activeNames" class="collapse-main-content">
            <el-collapse-item name="5">
              <template slot="title">
                <div class="collapse-title-pre">
                  <span></span>
                  收货地址
                </div>
              </template>
              <div class="collapse-content">
                <div class="tableStyle">
                  <vxe-grid
                    border
                    show-overflow
                    resizable
                    ref="receiveAddressTable"
                    class="vxe-table-element"
                    size="mini"
                    align="center"
                    :auto-resize="true"
                    :data="baseData.consigneeAddressList"
                    :columns="receiveAddressColumns"
                    :toolbar="{}"
                    :edit-rules="receiverAddressEditRules"
                    :edit-config="!forbidden ? { trigger: 'click', mode: 'row' } : {}"
                    :valid-config="{ autoPos: true, message: 'inline' }"
                  >
                    <template v-slot:buttons v-if="!forbidden">
                      <vxe-button
                        @click="$refs.receiveAddressTable.commitProxy('insert_actived')"
                        type="primary"
                        size="medium"
                        class="vxe-btn-primary"
                        >新增收货地址</vxe-button
                      >
                      <vxe-button
                        @click="handleDelete('receiveAddressTable')"
                        type="primary"
                        size="medium"
                        class="vxe-btn-delete"
                        >{{ $t('cooperation.buttons.delete') }}</vxe-button
                      >
                    </template>
                  </vxe-grid>
                </div>
              </div>
            </el-collapse-item></el-collapse
          >
          <el-collapse v-model="activeNames" class="collapse-main-content">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="collapse-title-pre">
                  <span></span>
                  附件文档
                </div>
              </template>
              <div class="collapse-content">
                <el-row :gutter="10">
                  <el-col :span="18">
                    <!-- <upload
                @upload="handleUpload"
                :tableData="baseData.partnersAttachments || []"
                :cooperationList="true"
                :isShow="!this.forbidden"
              /> -->
                    <FileTable
                      ref="fileTableRef"
                      :attachments="baseData.partnersAttachments || []"
                      :isShowDownBtn="forbidden"
                    ></FileTable>
                  </el-col>
                </el-row>
              </div> </el-collapse-item
          ></el-collapse>

          <!-- 扩展申请弹窗 -->
          <!-- :subjectProcureList="this.subjectProcureList"
            :subjectList="this.subjectList" -->
          <expand
            ref="expand"
            :forbidden="this.forbidden"
            @getDetail="getDetail"
            @clearRepeatData="clearRepeatData"
            @getExpandData="getExpandData"
            @partnerTypeChange="partnerTypeChange"
            @changeCountry="changeCountry"
          />
        </div>
        <!-- <div class="baseData">
          <el-form
            :disabled="forbidden"
            :model="baseData"
            :rules="rules"
            ref="baseData"
            label-width="105px"
          >
            <el-row :gutter="10">
              <!== 国内合作伙伴 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.ifDomestic')" prop="ifDomestic">
                  <el-select
                    @change="resolveRules($event, 'ifDomestic')"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.ifDomestic"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of countryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 个人合作伙伴 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.ifPersonalPartner')"
                  prop="ifPersonalPartner"
                >
                  <el-select
                    @change="resolveRules"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.ifPersonalPartner"
                    clearable
                    filterable
                  >
                    <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                    <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 授信合作伙伴 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.ifCreditPartner')"
                  prop="ifCreditPartner"
                >
                  <el-select
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.ifCreditPartner"
                    clearable
                    filterable
                  >
                    <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                    <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 合作伙伴类型 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.partnerType')" prop="partnerType">
                  <el-select
                    @change="partnerTypeChange"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.partnerType"
                    :disabled="forbidden"
                    filterable
                  >
                    <el-option
                      v-for="item of partnerTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 统一社会信用代码 ==>
              <el-col :span="6">
                <el-form-item
                  class="textOver"
                  :label="$t('cooperation.label.creditCode')"
                  prop="creditCode"
                >
                  <el-input
                    @blur="handleInputHover('creditCode')"
                    :placeholder="$t('cooperation.placeholder.creditCode')"
                    v-model.trim="baseData.creditCode"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!== 法人 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.legalPerson')" prop="legalPerson">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.legalPerson')"
                    v-model="baseData.legalPerson"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!== 法人类型 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.legalEntityType')"
                  prop="legalEntityType"
                >
                  <el-select
                    v-model="baseData.legalEntityType"
                    :placeholder="$t('cooperation.placeholder.legalEntityType')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of legalList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 身份证号 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.identityNo')" prop="identityNo">
                  <el-input
                    @blur="handleInputHover('identityNo')"
                    :placeholder="$t('cooperation.placeholder.identityNo')"
                    v-model.trim="baseData.identityNo"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 开票地址 ==>
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoiceAddress')" prop="invoiceAddress">
                  <el-tooltip
                    :disabled="!baseData.invoiceAddress"
                    class="item"
                    effect="dark"
                    :content="baseData.invoiceAddress"
                    placement="top"
                  >
                    <el-input
                      :placeholder="$t('cooperation.placeholder.invoiceAddress')"
                      v-model="baseData.invoiceAddress"
                      clearable
                      maxlength="64"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <!== 开票电话 ==>
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoicePhone')" prop="invoicePhone">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoicePhone')"
                    v-model="baseData.invoicePhone"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!== 开票银行名称 ==>
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankName')"
                  prop="invoiceBankName"
                >
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoiceBankName')"
                    v-model="baseData.invoiceBankName"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!== 开票银行账号 ==>
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankAccount')"
                  prop="invoiceBankAccount"
                >
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoiceBankAccount')"
                    v-model="baseData.invoiceBankAccount"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 注册资本 ==>
              <el-col :span="6">
                <el-row :gutter="10">
                  <el-col :span="16">
                    <el-form-item
                      :label="$t('cooperation.label.registeredAssets')"
                      prop="registeredAssets"
                    >
                      <el-tooltip
                        :disabled="!baseData.registeredAssets"
                        class="item"
                        effect="dark"
                        :content="String(baseData.registeredAssets)"
                        placement="top"
                      >
                        <input-number
                          :max="99999999999.999999"
                          :precision="6"
                          :placeholder="$t('cooperation.placeholder.registeredAssets')"
                          v-model="baseData.registeredAssets"
                          clearable
                        >
                        </input-number>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="currencyType">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="getSelectLabel(baseData.currencyType) + ''"
                        placement="top"
                        :disabled="!baseData.currencyType"
                      >
                        <el-select
                          filterable
                          v-model="baseData.currencyType"
                          :placeholder="$t('cooperation.placeholder.currencyType')"
                          clearable
                        >
                          <el-option
                            v-for="item of tradeCurrencylist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!== 成立日期 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.establishedDate')"
                  prop="establishedDate"
                >
                  <el-date-picker
                    v-model="baseData.establishedDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('cooperation.placeholder.establishedDate')"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <!== 所属集团 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.partnerParentCompany')"
                  prop="partnerParentCompanyCode"
                >
                  <search-table
                    v-model="baseData.partnerParentCompanyCode"
                    searchType="partnerParent"
                    :isMultiple="true"
                    :disabled="forbidden"
                    :currentValue="baseData.partnerParentCompanyName || null"
                    :checkRowKeys="[baseData.partnerParentCompanyCode]"
                    :isNeedMultipleValue="true"
                    :extraData="{ partnerCode: topData.partnerCode }"
                    @input="setPartnerParent"
                  ></search-table>
                </el-form-item>
              </el-col>
              <!== 人员识别号 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.personnelIdentificationNumber')"
                  prop="personnelIdentificationNumber"
                  :rules="hrRules"
                >
                  <el-input
                    :placeholder="$t('cooperation.placeholder.personnelIdentificationNumber')"
                    v-model="baseData.personnelIdentificationNumber"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 企业类型 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.enterpriseType')" prop="enterpriseType">
                  <el-select
                    v-model="baseData.enterpriseType"
                    :placeholder="$t('cooperation.placeholder.enterpriseType')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of enterpriseTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 发票类型 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.taxType')" prop="taxType">
                  <el-select
                    v-model="baseData.taxType"
                    :placeholder="$t('cooperation.placeholder.taxType')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of taxTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 交易币种 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.tradeCurrency')" prop="tradeCurrency">
                  <el-select
                    filterable
                    v-model="baseData.tradeCurrency"
                    :placeholder="$t('cooperation.placeholder.tradeCurrency')"
                    clearable
                    :disabled="partnerDetail.requestStatus == 'ZT03'"
                  >
                    <el-option
                      v-for="item of tradeCurrencylist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.partnerForm')" prop="partnerForm">
                  <el-select
                    filterable
                    v-model="baseData.partnerForm"
                    :placeholder="$t('cooperation.placeholder.partnerForm')"
                    clearable
                  >
                    <el-option
                      v-for="item of partnerFormList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 省份/城市 ==>
              <el-col :span="6">
                <el-row :gutter="10">
                  <el-col :span="16" style="padding-right: 0">
                    <el-form-item :label="$t('cooperation.label.province')" prop="province">
                      <el-select
                        filterable
                        v-model="baseData.province"
                        @change="changeProvince"
                        :placeholder="$t('cooperation.placeholder.province')"
                        clearable
                      >
                        <el-option
                          v-for="item of provinceList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="city">
                      <el-select
                        filterable
                        v-model="baseData.city"
                        :placeholder="$t('cooperation.placeholder.city')"
                        clearable
                      >
                        <el-option
                          v-for="item of cityList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!== 街道地址/门牌号 ==>
              <!== <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="24" style="padding-right: 0">
                    <el-form-item class="textOver" :label="$t('cooperation.label.streetAddress')" prop="streetAddress">
                      <el-input v-model="baseData.streetAddress" :placeholder="$t('cooperation.placeholder.streetAddress')" clearable maxlength="32"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col> ==>
              <!== 搜索简码 ==>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.searchCode')" prop="searchCode">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.searchCode')"
                    v-model="baseData.searchCode"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.postCode')" prop="postCode">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.postCode')"
                    v-model="baseData.postCode"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.taxpayerType')" prop="taxpayerType">
                  <el-select
                    filterable
                    v-model="baseData.taxpayerType"
                    :placeholder="$t('cooperation.placeholder.taxpayerType')"
                    clearable
                  >
                    <el-option
                      v-for="item of taxpayerTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-if="baseData.partnerType == 'HZHB07'">
              <!== 库容限额 ==>
              <el-col :span="6">
                <el-row :gutter="10">
                  <el-col :span="16">
                    <el-form-item
                      :label="$t('cooperation.label.capacityLimitAmount')"
                      prop="capacityLimitAmount"
                    >
                      <el-tooltip
                        :disabled="!baseData.capacityLimitAmount"
                        class="item"
                        effect="dark"
                        :content="String(baseData.capacityLimitAmount)"
                        placement="top"
                      >
                        <input-number
                          :max="99999999999.999999"
                          :precision="6"
                          :placeholder="$t('cooperation.placeholder.capacityLimitAmount')"
                          v-model="baseData.capacityLimitAmount"
                          clearable
                        >
                        </input-number>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item class="isShowLabel" prop="capacityLimitCurrencyCode">
                      <el-tooltip
                        :disabled="!baseData.capacityLimitCurrencyName"
                        class="item"
                        effect="dark"
                        :content="String(baseData.capacityLimitCurrencyName)"
                        placement="top"
                      >
                        <el-select
                          filterable
                          v-model="baseData.capacityLimitCurrencyCode"
                          @change="capacityLimitCurrency"
                          :placeholder="$t('cooperation.placeholder.currencyType')"
                          clearable
                        >
                          <el-option
                            v-for="item of tradeCurrencylist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 行业 ==>
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.industryName')" prop="industryName">
                  <el-select
                    filterable
                    v-model="baseData.industryName"
                    :placeholder="$t('cooperation.placeholder.industryName')"
                    clearable
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item of industryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 是否为关联方 ==>
              <el-col :span="12">
                <el-form-item label="是否为关联方" prop="isRelatedParty">
                  <el-select
                    filterable
                    v-model="baseData.isRelatedParty"
                    placeholder="请选择是否为关联方"
                    clearable
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item of yesnoList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 街道地址/门牌号  ==>
              <el-col :span="24">
                <el-form-item :label="$t('cooperation.label.streetAddress')" prop="streetAddress">
                  <el-input
                    v-model="baseData.streetAddress"
                    :placeholder="$t('cooperation.placeholder.streetAddress')"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!== 备注 ==>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('cooperation.label.mark')" prop="mark">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.mark')"
                    v-model="baseData.mark"
                    clearable
                    maxlength="80"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!== 申请原因 ==>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('cooperation.label.applyReason')" prop="mark">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.applyReason')"
                    v-model="baseData.applyReason"
                    clearable
                    maxlength="80"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!== 银行数据表格 ==>
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="partnersBanks"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="baseData.partnersBanks"
              :columns="bankColumnList"
              :edit-rules="bankTableEditRules"
              :toolbar="{}"
              :edit-config="forbidden ? {} : { trigger: 'click', mode: 'row' }"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-if="!forbidden" v-slot:buttons>
                <vxe-button
                  @click="$refs.partnersBanks.commitProxy('insert_actived')"
                  type="primary"
                  icon="el-icon-plus"
                  class="vxe-btn-primary"
                  >{{ $t('cooperation.buttons.add') }}</vxe-button
                >
                <vxe-button
                  @click="handleDelete('partnersBanks')"
                  type="primary"
                  icon="el-icon-delete"
                  class="vxe-btn-delete"
                  >{{ $t('cooperation.buttons.delete') }}</vxe-button
                >
                <vxe-button @click="handleSave('ZT06')" type="primary" class="vxe-btn-primary">{{
                  $t('cooperation.buttons.save')
                }}</vxe-button>
              </template>
            </vxe-grid>
          </div>
          <!== 联系人表格 ==>
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="partnersPersons"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="baseData.partnersPersons"
              :columns="linkColumnList"
              :toolbar="{}"
              :edit-rules="linkTableEditRules"
              :edit-config="forbidden ? {} : { trigger: 'click', mode: 'row' }"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-if="!forbidden" v-slot:buttons>
                <vxe-button
                  @click="$refs.partnersPersons.commitProxy('insert_actived')"
                  type="primary"
                  icon="el-icon-plus"
                  class="vxe-btn-primary"
                  >{{ $t('cooperation.buttons.add') }}</vxe-button
                >
                <vxe-button
                  @click="handleDelete('partnersPersons')"
                  type="primary"
                  icon="el-icon-delete"
                  class="vxe-btn-delete"
                  >{{ $t('cooperation.buttons.delete') }}</vxe-button
                >
                <vxe-button @click="handleSave('ZT06')" type="primary" class="vxe-btn-primary">{{
                  $t('cooperation.buttons.save')
                }}</vxe-button>
              </template>
            </vxe-grid>
          </div>
          <upload
            @upload="handleUpload"
            :tableData="baseData.partnersAttachments || []"
            :showSave="!forbidden"
            @handleSave="handleSave('ZT06')"
            :isShow="!forbidden"
          />
          <!== 扩展申请弹窗 ==>
          <expand
            ref="expand"
            :forbidden="this.forbidden"
            :sellForbid="this.sellForbid"
            :purchaseForbid="this.purchaseForbid"
            :subjectProcureList="this.subjectProcureList"
            :subjectList="this.subjectList"
            :purchaseSubjectRule="this.purchaseSubjectRule"
            :sellSubjectRule="this.sellSubjectRule"
            @getDetail="getDetail"
            @clearRepeatData="clearRepeatData"
            @getExpandData="getExpandData"
            @partnerTypeChange="partnerTypeChange"
            @changeCountry="changeCountry"
            @resolveSellRules="resolveSellRules"
          />
        </div> -->
      </el-tab-pane>
      <!-- <!== 销售数据 ==>
      <el-tab-pane :label="$t('cooperation.tabsName.salesData')" name="salesData">
        <div class="salesData">
          <el-form
            :disabled="forbidden || sellForbid"
            :model="salesData"
            :rules="rules"
            ref="salesData"
            label-width="80px"
          >
            <el-row :gutter="10">
              <!== 对账科目 ==>
              <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('cooperation.label.sellReconciliationSubject')"
                      prop="sellReconciliationSubject"
                      :rules="sellSubjectRule"
                    >
                      <!== <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top"
                      :disabled="!salesData.sellReconciliationSubject"
                      :content="salesData.sellReconciliationSubject ?
                      subjectList.find(item => item.value === salesData.sellReconciliationSubject).label : ''" > ==>
                      <el-select
                        :clearable="true"
                        :filterable="true"
                        :placeholder="$t('cooperation.placeholder.sellReconciliationSubject')"
                        v-model="salesData.sellReconciliationSubject"
                        @change="sellReconciliationSubjectChange"
                      >
                        <el-option
                          v-for="item of subjectList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <!== </el-tooltip> ==>
                    </el-form-item>
                  </el-col>
                  <!== 描述 ==>
                  <el-col :span="12">
                    <el-form-item class="isShowLabel" prop="sellReconciliationSubjectDesc">
                      <el-input
                        :placeholder="$t('cooperation.placeholder.sellReconciliationSubjectDesc')"
                        v-model="salesData.sellReconciliationSubjectDesc"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 收款方式 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.sellReceiptMethod')"
                  prop="sellReceiptMethod"
                >
                  <!== <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top"
                      :disabled="!salesData.sellReceiptMethod"
                      :content="salesData.sellReceiptMethod ?
                      paymentList.find(item => item.value === salesData.sellReceiptMethod).label : ''" > ==>
                  <el-select
                    :placeholder="$t('cooperation.placeholder.sellReceiptMethod')"
                    v-model="salesData.sellReceiptMethod"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of paymentList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <!== </el-tooltip> ==>
                </el-form-item>
              </el-col>
              <!== 开票条件 ==>
              <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('cooperation.label.sellInvoiceCondition')"
                      prop="sellInvoiceCondition"
                    >
                      <el-select
                        :placeholder="$t('cooperation.placeholder.sellInvoiceCondition')"
                        v-model="salesData.sellInvoiceCondition"
                        clearable
                        filterable
                      >
                        <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                        <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item class="isShowLabel" prop="sellInvoiceConditionDesc">
                      <el-input
                        :placeholder="$t('cooperation.placeholder.sellInvoiceConditionDesc')"
                        v-model="salesData.sellInvoiceConditionDesc"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <!== 采购数据 ==>
      <el-tab-pane :label="$t('cooperation.tabsName.purchasingData')" name="purchasingData">
        <div class="purchasingData">
          <el-form
            :disabled="forbidden || purchaseForbid"
            :model="purchasingData"
            :rules="rules"
            ref="purchasingData"
            label-width="80px"
          >
            <el-row :gutter="10">
              <!== 对账科目 ==>
              <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('cooperation.label.procurementReconciliationSubject')"
                      prop="procurementReconciliationSubject"
                      :rules="purchaseSubjectRule"
                    >
                      <el-select
                        :clearable="true"
                        :filterable="true"
                        :placeholder="
                          $t('cooperation.placeholder.procurementReconciliationSubject')
                        "
                        v-model="purchasingData.procurementReconciliationSubject"
                        @change="procurementReconciliationSubjectChange"
                      >
                        <el-option
                          v-for="item of subjectProcureList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!== 对账科目描述 ==>
                    <el-form-item class="isShowLabel" prop="procurementReconciliationSubjectDesc">
                      <el-input
                        :placeholder="$t('cooperation.placeholder.sellReconciliationSubjectDesc')"
                        v-model="purchasingData.procurementReconciliationSubjectDesc"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 收款方式 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.procurementReceiptMethod')"
                  prop="procurementReceiptMethod"
                >
                  <el-select
                    :placeholder="$t('cooperation.placeholder.procurementReceiptMethod')"
                    v-model="purchasingData.procurementReceiptMethod"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of paymentList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!== 付款条件 ==>
              <el-col :span="12">
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('cooperation.label.procurementPayCondition')"
                      prop="procurementPayCondition"
                    >
                      <el-select
                        :placeholder="$t('cooperation.placeholder.procurementPayCondition')"
                        v-model="purchasingData.procurementPayCondition"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item of receiptList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item class="isShowLabel" prop="procurementPayConditionDesc">
                      <el-input
                        :placeholder="$t('cooperation.placeholder.procurementPayConditionDesc')"
                        v-model="purchasingData.procurementPayConditionDesc"
                        clearable
                        maxlength="32"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <!== 订单货币 ==>
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.procurementCurrency')"
                  prop="procurementCurrency"
                >
                  <el-input
                    :placeholder="$t('cooperation.placeholder.procurementCurrency')"
                    v-model="purchasingData.procurementCurrency"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!== 保证金金额 ==>
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.procurementDepositAmount')"
                  prop="procurementDepositAmount"
                >
                  <input-number
                    :clearable="true"
                    v-model="purchasingData.procurementDepositAmount"
                    :precision="6"
                    :max="'99999999999.999999'"
                    :placeholder="$t('cooperation.placeholder.procurementDepositAmount')"
                  >
                  </input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane> -->
      <!-- 映射表 -->
      <!-- 扩展信息 -->
      <el-tab-pane :label="$t('cooperation.tabsName.extendedInformation')">
        <extended
          ref="extendedInformation"
          :isEdit="false"
          :tableData="partnerDetail.extendInfos || []"
        />
      </el-tab-pane>
      <el-tab-pane label="历史记录">
        <!-- 历史数据 -->
        <div class="tableStyle">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="historyRecordsTable"
            class="vxe-table-element"
            size="mini"
            align="center"
            :auto-resize="true"
            :data="baseData.dataHistories"
            :columns="historyRecordsColumnList"
            :toolbar="{}"
            :valid-config="{ autoPos: true, message: 'inline' }"
          >
            <!-- <template v-slot:buttons>
                        <vxe-button
                          @click="$refs.partnersBanks.commitProxy('insert_actived')"
                          type="primary"
                          size="medium"
                          class="vxe-btn-primary"
                          >新增银行</vxe-button
                        >
                        <vxe-button
                          @click="handleDelete('partnersBanks')"
                          type="primary"
                          size="medium"
                          class="vxe-btn-delete"
                          >{{ $t('cooperation.buttons.delete') }}</vxe-button
                        >
                      </template> -->
          </vxe-grid>
        </div>
      </el-tab-pane>
      <el-tab-pane label="系统映射表">
        <mapping-data
          ref="mappingData"
          :isEdit="true"
          :dataMapping="partnerDetail.systemMaps || []"
          :callLogsData="partnerDetail.callLogs || []"
          v-if="partnerDetail"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 底部按钮 -->
    <footer class="footer-bottom-list">
      <el-button
        v-hasPermi="['2021050815340830140']"
        class="fixed-bottom-btn"
        type="primary"
        v-show="partnerDetail.requestStatus != 'ZT03' && !saveforbidden"
        @click="save('ZT06')"
        >{{ $t('cooperation.buttons.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815342448426']"
        class="fixed-bottom-btn"
        type="primary"
        v-show="!forbidden || sendforbidden"
        @click="save('ZT02')"
        >{{ $t('cooperation.buttons.submit') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815360749546']"
        class="fixed-bottom-btn"
        type="primary"
        v-show="partnerDetail.requestStatus == 'ZT03'"
        @click="expand"
        >{{ $t('cooperation.buttons.expand') }}
      </el-button>

      <el-button
        v-hasPermi="['2021050815344363747']"
        @click="handleEdit"
        style="width: 100px"
        type="primary"
        >{{ $t('cooperation.buttons.seeOrEdit') }}</el-button
      >
      <!-- <el-button style="width: 100px" type="primary">{{$t('cooperation.buttons.submit')}}</el-button> -->
      <el-button
        v-hasPermi="['2021050815350771184']"
        @click="handleExport"
        style="width: 100px"
        type="primary"
        >{{ $t('cooperation.buttons.export') }}</el-button
      >
      <el-button
        type="primary"
        @click="sureOpenReject(1)"
        v-if="isApproval && partnerDetail.requestStatus == 'ZT02'"
        >批准</el-button
      >
      <el-button
        type="primary"
        @click="sureOpenReject(2)"
        v-if="isReject && partnerDetail.requestStatus == 'ZT02'"
        >驳回</el-button
      >
      <!-- <el-button type="primary"
      v-hasPermi = "['2021050815352382997']"
      style="width: 100px" :loading="loading" @click="syncMdg()">{{this.$t("goods.button.mdg")}}</el-button> -->
      <!-- <el-button
        v-hasPermi="['2021050815354355811']"
        @click="creditApply"
        v-show="showBtn"
        style="width: 100px"
        type="primary"
        >{{ $t('cooperation.buttons.credit_limit_application') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815355573958']"
        @click="creditSee"
        v-show="showBtn"
        style="width: 100px"
        type="primary"
        >{{ $t('cooperation.buttons.credit_limit_see') }}</el-button
      > -->
    </footer>
    <reject ref="reject" @handleSure="handleSure" />
  </div>
</template>

<script>
  import API from '@/api/masterData/cooperation';
  import FileTable from '@/components/business/FileTable/index.vue';
  import BASE_API from '@/api/dataBase';
  import { mapState } from 'vuex';
  // import upload from '@/components/upload';
  import { dateTimeFormat, dateFormat } from '@/filters';
  import {
    bankTableEditRules,
    checkPhone,
    partLinkTableEditRules,
    receiverAddressEditRules,
  } from './rules/tableRules.js';
  import InputNumber from '@/components/form-item/input-number';
  import SearchTable from '@/components/form-item/search-table';
  import Reject from './dialog/reject'; // 审批弹窗
  import {
    deliverRules,
    personalRules,
    domesticEnterprisesRules,
    foreignRules,
    foreignRulesParterPerson,
    foreignRulesPerson,
    hrRule,
    personalRulesParter,
    domesticEnterprisesRulesParter,
    foreignRulesParter,
  } from './rules/rules';
  import Expand from './dialog/expand';
  import mappingData from './components/mappingData'; // 系统映射表
  import loading from '@/common/js/load.js'; //loading
  import Extended from './components/extended'; // 扩展信息
  import { toFormErrorTop } from '@/common/js/util';
  import DeliverInfo from './components/deliverInfo';
  import { getLocalStorage } from '@/common/js/util.js';
  import BankSearchModel from '../components/bankSearchModel/bankSearchModel.vue';
  export default {
    name: 'editCooperation',
    components: {
      Expand,
      InputNumber,
      FileTable,
      SearchTable,
      mappingData,
      Extended,
      DeliverInfo,
      Reject,
    },
    computed: {
      curAssoListString() {
        if (
          this.baseData.associatedPartnerName &&
          this.baseData.associatedPartnerName.length != 0
        ) {
          return this.baseData.associatedPartnerName
            .map((item) => {
              return item.partnerZhName;
            })
            .join(',');
        }
        return '';
      },
      curAssoCodes() {
        if (
          this.baseData.associatedPartnerName &&
          this.baseData.associatedPartnerName.length != 0
        ) {
          return this.baseData.associatedPartnerName.map((item) => {
            return item.partnerCode;
          });
        }
        return [];
      },
      bankColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'bankName',
            title: this.$t('cooperation.label.bankName'),
            showHeaderOverflow: true,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.bankName}</span>];
              },
              edit: ({ row }) => {
                return [
                  // <search-table
                  //   searchType="bank"
                  //   isMultiple={true}
                  //   currentValue={row['bankName']}
                  //   checkRowKeys={[row['bankName']]}
                  //   onInput={(val) => this.chooseTable(val, row)}
                  // ></search-table>,
                  <BankSearchModel
                    searchType="bank"
                    isMultiple={true}
                    currentValue={row['bankName']}
                    checkRowKeys={[row['bankName']]}
                    onInput={(val) => this.chooseTable(val, row)}
                  ></BankSearchModel>,
                ];
              },
            },
          },
          {
            field: 'bankCode',
            title: this.$t('cooperation.label.bankCode'),
          },
          {
            field: 'associatedLineNumber',
            title: this.$t('cooperation.label.associatedLineNumber'),
          },
          {
            field: 'accountBankBranch',
            title: this.$t('cooperation.label.accountBankBranch'),
          },
          {
            field: 'bankAccount',
            title: this.$t('cooperation.label.bankAccount'),
            editRender: {
              name: 'ElInput',
              props: { clearable: true },
              events: {
                input: (obj) => this.bankAccountInput(obj.row, obj.row['bankAccount']),
              },
            },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      linkColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'contactPersonName',
            title: this.$t('cooperation.label.contactPersonName'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mobilePhone',
            title: this.$t('cooperation.label.mobilePhone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'telephone',
            title: this.$t('cooperation.label.telephone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'faxNo',
            title: this.$t('cooperation.label.faxNo'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'email',
            title: this.$t('cooperation.label.email'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'address',
            title: this.$t('cooperation.label.address'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      fileColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { field: 'attachmentName', title: this.$t('cooperation.label.attachmentName') },
          { field: 'createBy', title: this.$t('upload.uploader') },
          { field: 'gmtCreate', title: this.$t('upload.uploadDate') },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // // 收款方式
        // paymentList() {
        //   return this.$baseRequest.getDictListByType('payment_method');
        // },
        // // 获取付款条件
        // receiptList() {
        //   return this.$baseRequest.getDictListByType('payConditionPurchase');
        // },
        // 合作伙伴类型
        partnerTypeList() {
          return this.$baseRequest.getDictListByType('partner_type');
        },
        // 国家
        countryList() {
          return this.$baseRequest.getDictListByType('person_national');
        },
        // 省
        provinceListCN() {
          return this.$baseRequest.getDictListByType('province');
        },
        // 企业类型
        enterpriseTypeList() {
          return this.$baseRequest.getDictListByType('enterprise_type');
        },
        // 发票类型
        taxTypeList() {
          return this.$baseRequest.getDictListByType('tax_type');
        },
        // 邮政编码
        postCodeList() {
          return this.$baseRequest.getDictListByType('post_code');
        },
        // 法人分类
        legalEntityTypeList() {
          return this.$baseRequest.getDictListByType('legal_entity_type');
        },
        // 客户法人分类
        customerLegalEntityTypeList() {
          return this.$baseRequest.getDictListByType('customer_legal_entity_type');
        },
        // 行业
        industryList() {
          return this.$baseRequest.getDictListByType('industry_name');
        },
        //纳税人分类
        taxpayerTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'taxpayerType').dictList;
          }
        },
        //合作伙伴类别
        partnerFormList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'supplier_type').dictList;
          }
        },
        //合作伙伴类别
        yesnoList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'isAnotherPay').dictList;
          }
        },
      }),
      propsPartnerDetail() {
        let propsPartnerDetail = {
          id: this.$route.query.id,
          partnerCode: this.$route.query.partnerCode,
          departmentCode: this.$route.query?.departmentCode,
        };
        // this.propsPartnerData = propsPartnerDetail;
        // this.propsPartnerData.partnerCode=propsPartnerDetail.partnerCode;
        console.log(propsPartnerDetail);
        return propsPartnerDetail;
      },
      // 审批待办调转的参数
      fromFlag() {
        if (this.$route.query.from === 'todo') {
          return true;
        } else {
          return false;
        }
      },
    },
    data() {
      let newDate = dateFormat(new Date());
      const checkHasPhone = (cur, value, callback, _) => {
        const { row } = _;
        if (!row) {
          callback();
        }
        if (row.mobilePhone || row.telephone) {
          callback();
        } else {
          callback(new Error('请填写移动电话或固定电话'));
        }
      };
      const phoneValidate = {
        ...partLinkTableEditRules,
        mobilePhone: [
          { required: true, validator: checkHasPhone },
          {
            validator: checkPhone,
          },
        ],
        telephone: [
          {
            required: true,
            validator: checkHasPhone,
          },
        ],
      };
      return {
        activeNames: ['1', '2', '3', '4', '5', '6'],
        handleRejectValue: '',
        receiveAddressColumns: [
          { type: 'checkbox', width: '50' },
          {
            type: 'seq',
            title: '序号',
            visible: true,
            width: '80',
          },
          {
            field: 'addressAbbreviation',
            title: '地址简称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'consigneeAddress',
            title: '收货地址',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ],
        historyRecordsColumnList: [
          {
            type: 'seq',
            title: '序号',
            visible: true,
            width: '80',
          },
          {
            field: 'gmtCreate',
            title: '时间',
          },
          {
            field: 'createByName',
            title: '操作人',
          },
          {
            field: 'updateContent',
            title: '变更记录',
          },
          {
            field: 'operatorIp',
            title: '操作人IP',
          },
        ],
        activeNameTab: 'baseData',
        partnersExtendDTOList: [],
        propsPartnerData: {}, //合作伙伴对象
        auditReason: '',
        requestStatus: '',
        sendforbidden: false,
        saveforbidden: true,
        loading: false,
        showBtn: false, // 是否展示信用额度按钮
        showDeliverSection: false, //是否展示投送人模块信息
        sellForbid: true,
        purchaseForbid: true,
        todayDate: newDate,
        topData: {
          companyCode: '', // 公司代码
          companyName: '', // 公司名称
          departmentCode: '', // 业务部门
          departmentName: '', //部门名称
          requestTime: '', // 申请时间
          partnerCode: '', // 合作伙伴编码
          partnerZhName: '', // 合作伙伴名称中文
          partnerEnName: '', // 合作伙伴名称英文
          createBy: '', // 当前用户/创建人
          requestBy: '', // 申请人code
          businessPersonNo: '', //业务负责人编码
          busnessPersonName: '', //业务负责人名称
        },
        baseData: {
          partnerForm: null,
          taxpayerType: null, //纳税人
          ifDomestic: null, // 国内合作伙伴
          ifPersonalPartner: null, // 个人合作伙伴
          ifCreditPartner: null, // 授信合作伙伴
          partnerType: null, // 合作伙伴类型
          identityNo: null, // 身份证号
          creditCode: null, // 统一社会信用代码
          invoiceAddress: null, // 开票地址
          invoicePhone: null, // 开票电话
          invoiceBankName: null, // 开票银行名称
          invoiceBankAccount: null, // 开票银行账号
          legalPerson: null, // 法人
          legalEntityType: null, // 法人类型
          registeredAssets: null, // 注册资本
          currencyType: null, // 货币种类
          establishedDate: null, // 成立日期
          partnerParentCompanyCode: null, // 所属集团
          searchCode: null, // 搜索简码
          personnelIdentificationNumber: null, // 人员识别号
          tradeCurrency: null, // 交易币种
          industryName: null, // 行业
          enterpriseType: null, // 企业类型
          taxType: null, // 发票类型
          postCode: null, // 邮政编码
          province: null, // 省份
          provinceName: null,
          city: null, // 城市
          cityName: null,
          streetAddress: null, // 街道地址
          roomNo: null, // 门牌号
          mark: null, // 备注
          partnersBanks: [], // 银行表格
          partnersPersons: [], // 联系人表格
          partnersAttachments: null, // 附件表格
          applyReason: null, // 申请原因
          capacityLimitAmount: null,
          capacityLimitCurrencyCode: null,
          capacityLimitCurrencyName: null,
          isRelatedParty: null, //是否关联方

          //新加字段
          abbreviation: '', //合作伙伴简称
          partnerZhName: '', //合作伙伴名称
          businessScope: '', //经营范围
          licenseScope: '',
          licenseValid: '',
          permitScope: '',
          registrationAuthority: '', //登记机关
          approvalTime: '', //核准日期
          businessTerm: '', //营业期限
          actualAssets: '',

          associatedPartnerName: [],
          //投送人模块
          delivererName: '', //投送人姓名
          delivererPhone: '', //投送人电话
          delivererIdNo: '', //投送人身份证
          delivererIdDurationStart: '', //投送人身份证期限开始
          delivererIdDurationEnd: '', //投送人身份证期限结束
          delivererAddress: '', //投送人地址
          consigneeAddressList: [], //合作伙伴收货地址信息
          consigneeAddress: '', //合作伙伴收货地址信息转String,
          dataHistories: [], //历史信息,
        },
        // // salesData: {
        // //   sellReconciliationSubject: '', // 对账科目
        // //   sellReconciliationSubjectDesc: '', // 对账科目描述
        // //   sellReceiptMethod: '', // 收款方式
        // //   sellInvoiceCondition: '', // 开票条件
        // //   sellInvoiceConditionDesc: '', // 销售开票条件描述
        // // },
        // // purchasingData: {
        // //   procurementReconciliationSubject: '', // 对账科目
        // //   procurementReconciliationSubjectDesc: '', // 对账科目描述
        // //   procurementReceiptMethod: '', // 收款方式
        // //   procurementPayCondition: '', // 付款条件
        // //   procurementPayConditionDesc: '', // 付款条件描述
        // //   procurementCurrency: '', // 订单货币
        // //   procurementDepositAmount: '', // 保证金金额
        // // },
        bankTableEditRules: bankTableEditRules, // 银行表格校验规则
        linkTableEditRules: phoneValidate, // 联系人校验规则
        receiverAddressEditRules: receiverAddressEditRules, //收货人校验规则
        hrRules: [], // hr员工校验规则
        // sellSubjectRule: [], // 销售数据对账科目校验规则
        // purchaseSubjectRule: [], // 采购数据对账科目校验规则
        // // subjectList: [], // 对账科目销售
        // // subjectProcureList: [], //采购
        requestByList: [], // 申请人数据
        departmentList: [], // 部门数据
        provinceList: [], // 省份数据
        cityList: [], // 城市下拉数据
        tradeCurrencyList: [], // 交易币种下拉数据
        legalList: [], // 法人分类数据
        time: null, // 定时器
        rules: {}, // 校验规则
        partnerDetail: {},
        forbidden: true, // 是否禁用
        editConfig: {}, // vxe表格是否禁用
        ossUrl: '', // 附件上传地址
        ossData: {}, // 附件上传参数
        checkPartner: [], // 查重返回结果
        requestStatusList: [],
        requestStatusData: {},
        isReject: false, //判断是否有驳回权限
        isApproval: false, //判断是否有审批权限
      };
    },
    created() {
      this.getDictList();
    },
    // beforeDestroy() {
    //   clearInterval(this.time); // 清除定时器
    // },
    watch: {
      'baseData.registeredAssets': {
        handler(newName) {
          if (newName && typeof newName != 'number') {
            this.baseData.registeredAssets = newName.replace(/[^\d]/g, '');
          }
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.getDetail(this.propsPartnerDetail.departmentCode || this.userInfo.departmentCode);
      this.$nextTick(() => {
        this.getMenuButton();
      });
    },
    methods: {
      // 禁止输入空格
      avoidBlank(value) {
        if (value) {
          value = value.replace(/\s+/g, '');
        }
        return value;
      },
      // 银行信息-银行账户
      bankAccountInput(row, value) {
        row.bankAccount = this.avoidBlank(value);
      },
      // 开票信息-开票银行账户
      invoiceBankAccountInput(value) {
        this.baseData.invoiceBankAccount = this.avoidBlank(value);
      },
      formatPartnerName() {
        if (this.baseData.partnerZhName) {
          this.baseData.partnerZhName = this.baseData.partnerZhName.trim().replace(/\s/gi, '-');
        }
      },
      // 获取菜单按钮
      async getMenuButton() {
        // console.log("diayong",JSON.parse(this.userInfo).account)
        const { data } = await this.$axios.post(
          '/maindata/role/getRoleMenuButton' +
            '?MENU_CODE=' +
            '2019121908510205183' +
            '&USER_NAME=' +
            getLocalStorage('userInfo').userInfo.account
        );

        if (data?.code == 0) {
          data?.data?.map((item) => {
            if (item.label == '驳回' || item.attributes.buttonUrl == 'reject') {
              this.isReject = true;
            }
            if (item.label == '批准' || item.attributes.buttonUrl == 'approval') {
              this.isApproval = true;
            }
          });
        }
        console.log('data', data);
      },
      // 审批
      sureOpenReject(val) {
        console.log(val, '111111');
        this.handleRejectValue = val == 1 ? 'ZT03' : 'ZT05';
        this.$refs.reject.openDialog('', val);
      },
      handleSure(val, type) {
        this.handleReject(this.handleRejectValue, this.$route.query.id, val, type);
      },
      handleReject(val, idList, reason, type) {
        if (val) {
          // let params = {
          //   ids: [idList],
          //   requestStatus: val,
          //   auditReason: reason,
          // };
          let params = [{ extendId: idList, type, auditReason: reason }];
          loading.startLoading();
          this.$axios.post(API.UPDATE_IS_REJECT, params).then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.idList = [];
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.$router.go(-1);
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 关闭的时候数据校验
      // async closeEditTableHandler(tableRef) {
      //   const $table = this.$refs[tableRef];
      //   const errMap = await $table.validate().catch((errMap) => errMap);
      //   if (errMap) {
      //     this.$message.error('请检查数据再提交');
      //   } else {
      //     await $table.clearActived();
      //   }

      //   if (tableRef == 'receiveAddressTable') {
      //     if (this.checkAddressRepeat()) {
      //       this.$message({ showClose: true, message: '地址简称重复！', type: 'error' });
      //     }
      //   }
      // },
      checkAddressRepeat() {
        let consigneeAddressList = this.$refs.receiveAddressTable.getTableData().fullData;
        let tempAddress = '';
        let repeat = false;
        //检查简称是否重复
        if (consigneeAddressList) {
          consigneeAddressList.forEach((item) => {
            console.log('addressItem', item);
            if (item.addressAbbreviation == tempAddress) {
              repeat = true;
            } else {
              tempAddress = item.addressAbbreviation;
            }
          });
        }
        return repeat;
      },
      //表格组件下拉框选择回调
      getSelectLabel(value) {
        let item = this.tradeCurrencyList.find((item) => {
          return value == item.value;
        });
        return item ? item.label : null;
      },
      //获取值
      chooseTable(val, row) {
        row.bankName = val[0].bankName || '-';
        row.bankCode = val[0].bankCode || '-';
        row.associatedLineNumber = val[0].bankUnionNumber || '-';
        row.accountBankBranch = val[0].branchName || '-';
      },
      getDetail(value) {
        const params = {
          id: this.propsPartnerDetail.id,
          partnerCode: this.propsPartnerDetail.partnerCode,
          departmentCode: value,
        };
        loading.startLoading();
        this.$axios
          .get(API.GET_PARTNER, params)
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.partnerDetail = res.data.data;
              // this.topData.partnerZhName = this.partnerDetail.partnerZhName;
              console.log(this.partnerDetail.extendInfos);
              this.legalList =
                this.partnerDetail.partnerType == 'HZHB01' ||
                this.partnerDetail.partnerType == 'HZHB03' ||
                this.partnerDetail.partnerType == 'HZHB10' ||
                this.partnerDetail.partnerType == 'HZHB11'
                  ? this.customerLegalEntityTypeList
                  : this.legalEntityTypeList;
              const formList = [
                'topData',

                'baseData',
                //
                //  'salesData', 'purchasingData'
              ];
              formList.forEach((el) => {
                Object.keys(this[el]).forEach((item) => {
                  this[el][item] = res.data.data[item];
                });
              });
              this.auditReason = res.data.data.auditReason;
              this.requestStatus = res.data.data.requestStatus;
              this.topData.requestBy = Number(this.topData.requestBy);
              let _self = this;
              var obj = this.requestByList.find((item) => {
                return item.id == _self.topData.requestBy;
              });
              if (obj) {
                this.topData.requestByName = obj.personName;
              }

              this.setCreateByName(this.topData.createBy);

              this.showBtn = this.partnerDetail.ifCreditPartner === '1' ? true : false;
              this.hrRules = this.partnerDetail.partnerType === 'HZHB04' ? hrRule : [];
              console.log('partnerType', this.partnerDetail.partnerType);
              this.showDeliverSection = this.partnerDetail.partnerType === 'HZHB13';
              this.baseData.partnerParentCompanyCode = res.data.data.partnerParentCompanyCode;
              this.baseData.partnerParentCompanyName = res.data.data.partnerParentCompanyName;
              this.topData.businessPersonNo = res.data.data.businessPersonNo;
              this.topData.busnessPersonName = res.data.data.busnessPersonName;
              this.baseData.partnerZhName = res.data.data.partnerZhName;

              this.baseData.partnersAttachments = res.data.data.partnersAttachments;

              //新加字段
              this.baseData.abbreviation = this.partnerDetail.abbreviation; //合作伙伴简称
              this.baseData.businessScope = this.partnerDetail.businessScope; //经营范围
              this.baseData.permitScope = this.partnerDetail.permitScope; //经营范围
              this.baseData.licenseScope = this.partnerDetail.licenseScope; //经营范围
              this.baseData.licenseValid = this.partnerDetail.licenseValid; //经营范围
              this.baseData.registrationAuthority = this.partnerDetail.registrationAuthority; //登记机关
              this.baseData.approvalTime = this.partnerDetail.approvalTime; //核准日期
              this.baseData.businessTerm = this.partnerDetail.businessTerm; //营业期限
              //投送人模块
              this.baseData.delivererName = this.partnerDetail.delivererName; //投送人姓名
              this.baseData.delivererPhone = this.partnerDetail.delivererPhone; //投送人电话
              this.baseData.delivererIdNo = this.partnerDetail.delivererIdNo; //投送人身份证
              this.baseData.delivererIdDurationStart = this.partnerDetail.delivererIdDurationStart; //投送人身份证期限
              this.baseData.delivererIdDurationEnd = this.partnerDetail.delivererIdDurationEnd; //投送人身份证期限

              console.log('dataget', this.baseData.delivererIdDurationStart);
              console.log('dataget', this.baseData.delivererIdDurationEnd);
              this.baseData.delivererAddress = this.partnerDetail.delivererAddress; //投送人地址
              this.baseData.consigneeAddressList = this.partnerDetail.consigneeAddressList; //合作伙伴收货地址信息
              this.baseData.consigneeAddress = this.partnerDetail.consigneeAddress; //合作伙伴收货地址信息转String,
              this.baseData.dataHistories = this.partnerDetail.dataHistories; //历史信息,

              //json串
              if (this.baseData.associatedPartnerName && this.baseData.associatedPartnerName) {
                try {
                  var list = JSON.parse(this.baseData.associatedPartnerName);
                  this.baseData.associatedPartnerName = list;
                  // this.baseData.associatedPartnerCode = list
                  //   .map((item) => item.partnerZhName)
                  //   .join(',');
                } catch (e) {
                  console.log('associatePartnerParseError', e);
                }
              }

              // 海宁注册申请人为空
              if (
                this.partnerDetail.requestStatus == 'ZT06' &&
                !this.topData.requestBy &&
                !this.topData.requestByName
              ) {
                this.topData.requestBy = this.userInfo.userCode;
                this.topData.requestByName = this.userInfo.userName;
              }
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .then(() => {
            setTimeout(() => {
              this.initLocationData();
            }, 500);
          })
          .then(() => {
            this.resolveRules(this.partnerDetail); // 判断使用的校验规则
          })
          .then(() => {
            // // this.resolveSellRules(this.partnerDetail.partnerType); // 根据合作伙伴类型判断销售/采购数据的校验规则
          });
        this.$nextTick(() => {
          this.activeNameTab = 'baseData';
          this.$refs.baseData.clearValidate();
        });
      },
      //库容限额选择币种获取中文
      capacityLimitCurrency(val) {
        this.baseData.capacityLimitCurrencyName = val
          ? this.tradeCurrencyList.find((item) => {
              return val == item.value;
            }).label
          : '';
      },
      save(type) {
        this.commonSave(type, 'UPDATE_PARTNERS');
      },
      //同步mdg
      syncMdg() {
        if (this.partnerDetail.requestStatus === 'ZT06') {
          return this.$message({
            showClose: true,
            message: this.$t('cooperation.message.canNotSync'),
            type: 'error',
          });
        }
        this.commonSave('ZT02', 'PARTNER_SYNCMDG');
      },
      // 获取扩展的数据
      getExpandData(data) {
        data.partnerType == 'HZHB01' ||
        data.partnerType == 'HZHB03' ||
        data.partnerType == 'HZHB10' ||
        data.partnerType == 'HZHB11'
          ? (this.legalList = this.customerLegalEntityTypeList)
          : (this.legalList = this.legalEntityTypeList);
        this.topData.partnerCode = data.partnerCode;
        this.topData.partnerZhName = data.partnerZhName;
        this.topData.partnerEnName = data.partnerEnName;
        Object.keys(this.baseData).forEach((item) => {
          this.baseData[item] = data[item];
        });
        this.forbidden = true;
        this.sendforbidden = true;
        if (this.partnerDetail.requestStatus == 'ZT03') {
          this.saveforbidden = false;
        }
        this.resolveRules();
      },
      // 合作伙伴类型切换
      partnerTypeChange(value) {
        this.baseData.legalEntityType = '';
        this.legalList =
          value == 'HZHB01' || value == 'HZHB03' || value == 'HZHB10' || value == 'HZHB11'
            ? this.customerLegalEntityTypeList
            : this.legalEntityTypeList;
        this.hrRules = value == 'HZHB04' ? hrRule : []; // hr员工,人员识别号必填
        if (value != 'HZHB07') {
          this.baseData.capacityLimitCurrencyCode = null;
          this.baseData.capacityLimitCurrencyName = null;
          this.baseData.capacityLimitAmount = null;
        }
        this.showDeliverSection = value === 'HZHB13';
        this.resolveRules();
      },
      // 扩展按钮点击事件
      expand() {
        console.log(this.propsPartnerData);
        let companyInfo = {
          companyName: this.topData.companyName,
          companyCode: this.topData.companyCode,
          departmentName: this.topData.departmentName,
          departmentCode: this.topData.departmentCode,
        };
        this.propsPartnerData.partnerZhName = this.baseData.partnerZhName;
        this.propsPartnerData.partnerCode = this.topData.partnerCode;
        console.log(this.propsPartnerData.partnerCode);
        this.$refs.expand.openDialog(
          this.propsPartnerData,
          this.partnerTypeList,
          '',
          this.departmentList,
          companyInfo
        );
      },
      // 打开扩展提醒弹窗
      handleExpand(checkPartner, value) {
        console.log(this.partnerDetail.extendInfos);
        if (this.checkPartner.length > 0) {
          this.$confirmAction(this.$t('cooperation.message.is_expand_apply'), '')
            .then(() => {
              console.log(this.departmentList);
              let companyInfo = {
                companyName: this.topData.companyName,
                companyCode: this.topData.companyCode,
                departmentName: this.topData.departmentName,
                departmentCode: this.topData.departmentCode,
              };
              console.log(companyInfo);
              this.$refs.expand.openDialog(
                this.checkPartner[0],
                this.partnerTypeList,
                value,
                this.departmentList,
                companyInfo
              );
            })
            .catch(() => {
              this.clearRepeatData(value);
            });
        }
      },
      // 身份证/社会统一代码校验去重
      handleInputHover(value) {
        let params = {
          creditCode: this.baseData.creditCode,
          identityNo: this.baseData.identityNo,
          extendId: this.$route.query.id,
          departmentCode: this.topData.departmentCode, // 查询当前部门是否重复
          requestStatus: 'ZT03', //【ID1002169】 只有已生效的可以扩展【合作伙伴主数据】已驳回状态仍可以扩展
        };
        // 全部门查重
        this.$axios.post(API.GET_CHECKING_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            // if (res.data.data.length > 0) {
            //   this.$confirmAction(this.$t('cooperation.message.data_repeat'), '')
            //   .then(() => {
            //     this.clearRepeatData(value);
            //   }).catch(() => {
            //     this.clearRepeatData(value);
            //   });
            // } else {

            // }
            if (res.data.data.length === 0) {
              // 全范围查重
              delete params.departmentCode;
              this.$axios.post(API.GET_CHECKING_PARTNER, params).then((res) => {
                if (res.data.code === 0) {
                  this.checkPartner = res.data.data;
                  this.handleExpand(this.checkPartner, value);
                }
              });
            } else {
              this.$confirmAction(this.$t('cooperation.message.data_repeat'), '')
                .then(() => {
                  // this.returnPath();
                })
                .catch(() => {
                  this.clearRepeatData(value);
                });
            }
          }
        });
      },
      //申请人
      setRequestPerson(row) {
        this.topData.requestBy = row ? row[0].id : null;
        this.topData.requestByName = row ? row[0].personName : null;
      },
      setBusinessPerson(row) {
        this.topData.busnessPersonName = row ? row[0].personName : null;
        this.topData.businessPersonNo = row ? row[0].id : null;
      },
      // 所属集团
      // setPartnerParent(row) {
      //   this.baseData.partnerParentCompanyCode = row ? row[0].partnerCode : '本身为母公司';
      //   this.baseData.partnerParentCompanyName = row ? row[0].partnerZhName : '本身为母公司';
      // },
      // setAssociatePartner(row) {
      //   // this.baseData.associatedPartners = row ? row[0].partnerZhName : '本身为母公司';
      //   // this.baseData.associatedPartnersCode = row ? row[0].partnerCode : '本身为母公司';
      //   var list = [];
      //   row.forEach(function (e) {
      //     list.push({ partnerZhName: e.partnerZhName, partnerCode: e.partnerCode });
      //   });
      //   this.baseData.associatedPartnerName = list;
      //   console.log('output', list);
      // },
      // 取消扩展操作恢复初始数据
      clearRepeatData(value) {
        this.baseData[value] = this.propsPartnerDetail[value];
      },
      // 合作伙伴名称变化
      getPartnerName(val) {
        this.$axios.post(`${API.GET_PARTNER_GROUP}`, { partnerName: val }).then((res) => {
          console.log(res.data);
          if (res.data.code === 0) {
            if (res.data.data) {
              this.baseData.partnerParentCompanyName = res.data.data.partnerCode;
              this.baseData.partnerParentCompanyCode = res.data.data.partnerZhName;
              this.$axios.get(`${API.IS_EXIST_BY_NAME}?partnerZhName=${val}`).then((res) => {
                if (res.data.code === 0) {
                  if (res.data.data) {
                    this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                    this.handleInputHover('partnerName');
                  }
                } else {
                  this.$alert(res.data.msg);
                }
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // handleSave(type) {
      //   loading.startLoading();
      //   let _self = this;
      //   let canSubmit = true;
      //   let promiseObjectList = [];
      //   function validates(formName) {
      //     let promiseObject = new Promise((resolve, reject) => {
      //       if (
      //         formName === 'partnersBanks' ||
      //         formName === 'partnersPersons' ||
      //         formName === 'receiveAddressTable'
      //       ) {
      //         _self.$refs[formName]
      //           .validate()
      //           .then(() => {
      //             resolve();
      //           })
      //           .catch(() => {
      //             reject(formName);
      //             canSubmit = false;
      //           });
      //       } else {
      //         _self.$refs[formName].validate((valid) => {
      //           if (valid) {
      //             resolve();
      //           } else {
      //             reject(formName);
      //             canSubmit = false;
      //           }
      //         });
      //       }
      //     });
      //     promiseObjectList.push(promiseObject);
      //   }
      //   // 校验
      //   const formList = [
      //     'topData',
      //     'baseData',
      //     'partnersBanks',
      //     'partnersPersons',
      //     'receiveAddressTable',
      //     // // 'salesData',
      //     // // 'purchasingData',
      //   ];
      //   formList.forEach((item) => {
      //     if (type !== 'ZT06') {
      //       validates(item);
      //     }
      //   });

      //   if (!canSubmit) {
      //     return;
      //   }
      //   // 合并对象
      //   let params = Object.assign(this.topData, this.baseData);
      //   // // params = Object.assign(params, this.salesData);
      //   // // params = Object.assign(params, this.purchasingData);
      //   params.partnersBanks = this.$refs.partnersBanks.getTableData().fullData;
      //   params.partnersPersons = this.$refs.partnersPersons.getTableData().fullData;
      //   params.consigneeAddressList = this.$refs.receiveAddressTable.getTableData().fullData;
      //   Promise.all(promiseObjectList)
      //     .then(() => {
      //       if (type === 'ZT02' && this.userInfo.adminFlag == 1) {
      //         // 判断用户角色
      //         params.requestStatus = 'ZT03';
      //       } else {
      //         params.requestStatus = type;
      //       }
      //       params.partnersBanks = JSON.stringify(params.partnersBanks);
      //       params.partnersPersons = JSON.stringify(params.partnersPersons);
      //       params.partnersAttachments = JSON.stringify(params.partnersAttachments);
      //       params.consigneeAddress = JSON.stringify(params.consigneeAddressList);
      //       if (params.associatedPartnerName && params.associatedPartnerName.length > 0) {
      //         params.associatedPartnerName = JSON.stringify(params.associatedPartnerName);
      //       }
      //       // 新增字段
      //       params.partnerCompanyName = params.companyName;
      //       params.partnerCompanyCode = params.companyCode;
      //       params.tenantCode = this.userInfo.tenantCode;
      //       params.requestCreateBy = params.createBy;
      //       params.version = this.partnerDetail.version;
      //       params.id = this.partnerDetail.id;
      //       params.extendId = this.propsPartnerDetail.id;

      //       // //新加字段
      //       // params.abbreviation = this.partnerDetail.abbreviation; //合作伙伴简称
      //       // params.businessScope = this.partnerDetail.businessScope; //经营范围
      //       // params.registrationAuthority = this.partnerDetail.registrationAuthority; //登记机关
      //       // params.approvalTime = this.partnerDetail.approvalTime; //核准日期
      //       // params.businessTerm = this.partnerDetail.businessTerm; //营业期限
      //       // //投送人模块
      //       // params.delivererName = this.partnerDetail.delivererName; //投送人姓名
      //       // params.delivererPhone = this.partnerDetail.delivererPhone; //投送人电话
      //       // params.delivererIdNo = this.partnerDetail.delivererIdNo; //投送人身份证
      //       // params.delivererIdDurationStart = this.partnerDetail.delivererIdDurationStart; //投送人身份证期限
      //       // params.delivererIdDurationEnd = this.partnerDetail.delivererIdDurationEnd; //投送人身份证期限
      //       // params.delivererAddress = this.partnerDetail.delivererAddress; //投送人地址
      //       // params.associatedPartnerName = this.partnerDetail.associatedPartnerName; //关联合作伙伴
      //       // params.associatedPartnerCode = this.partnerDetail.associatedPartnerCode;

      //       // this.$axios.post(API.UPDATE_PARTNERS, params).then(res => {
      //       //   this.loading.endLoading();
      //       // UPDATE_PARTNERS
      //       this.$axios.post(API.B_P_SAVE, params).then((res) => {
      //         loading.endLoading();
      //         if (res.data.code === 0) {
      //           this.$message({ showClose: true, message: res.data.msg, type: 'success' });
      //         } else {
      //           this.$message({ showClose: true, message: res.data.msg, type: 'error' });
      //         }
      //       });
      //     })
      //     .catch((err) => {
      //       if (err == 'baseData' || err == 'salesData' || err == 'purchasingData') {
      //         this.activeNameTab = err;
      //       } else {
      //         this.activeNameTab = 'baseData';
      //       }
      //       console.log(err);
      //       loading.endLoading();
      //       toFormErrorTop();
      //       this.$message({
      //         showClose: true,
      //         message: this.$t('cooperation.message.topFormCheckResult'),
      //         type: 'error',
      //       });
      //     });
      // },
      commonSave(type, api) {
        //type ZT06 保存 ZT02 提交
        let _self = this;
        let baseDataFlag = true;
        let topDataFlag = true;
        let promiseObjectList = [];
        // new Promise
        function validates(formName) {
          let promiseObject = new Promise((resolve, reject) => {
            if (
              formName === 'partnersBanks' ||
              formName === 'partnersPersons' ||
              formName === 'receiveAddressTable'
            ) {
              _self.$refs[formName]
                .validate()
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  reject(formName);
                });
            } else {
              _self.$refs[formName].validate((valid) => {
                if (valid) {
                  resolve();
                } else {
                  reject(formName);
                }
              });
            }
          });
          promiseObjectList.push(promiseObject);
        }
        // 校验
        const formList = [
          'topData',
          'baseData',
          'partnersBanks',
          'partnersPersons',
          'receiveAddressTable',
          // // 'salesData',
          // // 'purchasingData',
        ];
        if (type === 'ZT06') {
          this.$refs.baseData.validateField('partnerType', (valid) => {
            if (valid.length > 0) {
              baseDataFlag = false;
            } else {
              baseDataFlag = true;
            }
          });
          this.$refs.baseData.validateField('partnerZhName', (valid) => {
            if (valid.length > 0) {
              topDataFlag = false;
            } else {
              topDataFlag = true;
            }
          });
        } else {
          formList.forEach((item) => {
            validates(item);
          });
        }
        if (!topDataFlag || !baseDataFlag) {
          toFormErrorTop();
          return;
        }

        if (this.checkAddressRepeat()) {
          this.$message({ showClose: true, message: '地址简称重复！', type: 'error' });
          return;
        }

        loading.startLoading();
        // 合并对象
        let params = Object.assign(this.topData, this.baseData);
        // // params = Object.assign(params, this.salesData);
        // // params = Object.assign(params, this.purchasingData);
        params.partnersBanks = this.$refs.partnersBanks.getTableData().fullData;
        params.partnersPersons = this.$refs.partnersPersons.getTableData().fullData;
        params.consigneeAddressList = this.$refs.receiveAddressTable.getTableData().fullData;

        //后期修改
        params.currentDepartmentCode = this.userInfo.departmentCode;
        params.currentDepartmentName = this.userInfo.departmentName;
        params.currentCompanyName = this.userInfo.companyName;
        params.currentCompanyCode = this.userInfo.companyCode;

        Promise.all(promiseObjectList)
          .then(() => {
            if (type === 'ZT02' && this.userInfo.adminFlag == 1) {
              // 判断用户角色
              params.requestStatus = 'ZT07';
            } else {
              params.requestStatus = type;
            }
            if (this.partnerDetail.dataStatus == '已生效' && this.userInfo.adminFlag == 1) {
              params.requestStatus = 'ZT07';
            }
            if (this.partnerDetail.dataStatus == '已生效' && this.userInfo.adminFlag == 2) {
              params.requestStatus = 'ZT02';
            }
            params.partnersBanks = JSON.stringify(params.partnersBanks);
            params.partnersPersons = JSON.stringify(params.partnersPersons);
            params.partnersAttachments = this.$refs.fileTableRef.getTableData();
            params.partnersAttachments = JSON.stringify(params.partnersAttachments);
            params.consigneeAddress = JSON.stringify(params.consigneeAddressList);

            // 新增字段
            params.partnerCompanyName = params.companyName;
            params.partnerCompanyCode = params.companyCode;
            params.tenantCode = this.userInfo.tenantCode;
            var obj = this.requestByList.find((item) => {
              return item.personName == this.topData.createBy;
            });
            params.requestCreateBy = obj ? obj.id : this.topData.createBy;
            params.version = this.partnerDetail.version;

            // //新加字段
            // params.abbreviation = this.partnerDetail.abbreviation; //合作伙伴简称
            // params.businessScope = this.partnerDetail.businessScope; //经营范围
            // params.registrationAuthority = this.partnerDetail.registrationAuthority; //登记机关
            // params.approvalTime = this.partnerDetail.approvalTime; //核准日期
            // params.businessTerm = this.partnerDetail.businessTerm; //营业期限
            // //投送人模块
            // params.delivererName = this.partnerDetail.delivererName; //投送人姓名
            // params.delivererPhone = this.partnerDetail.delivererPhone; //投送人电话
            // params.delivererIdNo = this.partnerDetail.delivererIdNo; //投送人身份证
            // params.delivererIdDurationStart = this.partnerDetail.delivererIdDurationStart; //投送人身份证期限
            // params.delivererIdDurationEnd = this.partnerDetail.delivererIdDurationEnd; //投送人身份证期限
            // params.delivererAddress = this.partnerDetail.delivererAddress; //投送人地址
            // params.associatedPartnerName = this.partnerDetail.associatedPartnerName; //关联合作伙伴
            // params.associatedPartnerCode = this.partnerDetail.associatedPartnerCode;

            if (params.associatedPartnerName && params.associatedPartnerName.length != 0) {
              params.associatedPartnerName = JSON.stringify(
                params.associatedPartnerName.map((item) => {
                  return { partnerCode: item.partnerCode, partnerZhName: item.partnerZhName };
                })
              );
            } else {
              params.associatedPartnerName = null;
            }

            if (api == 'PARTNER_SYNCMDG') {
              params.id = this.$route.query.id;
            } else {
              params.id = this.partnerDetail.id;
            }
            if (api == 'SAVE_PARTNER_EXTEND') {
              params.partnersExtendDTOList = this.partnersExtendDTOList;
            }
            if (api == 'UPDATE_PARTNERS') params['partnerNames'] = [params.partnerZhName];
            params.extendId = this.propsPartnerDetail.id;
            // this.$axios.post(API.UPDATE_PARTNERS, params).then(res => {
            //   this.loading.endLoading();
            // UPDATE_PARTNERS
            this.$axios.post(API[api], params).then((res) => {
              loading.endLoading();
              if (res.data.code === 0) {
                if (type === 'ZT06') {
                  // this.dblclickEvent(this.$route.query)
                  this.getDetail(
                    this.propsPartnerDetail.departmentCode || this.userInfo.departmentCode
                  );
                } else {
                  /*  if(api=='UPDATE_PARTNERS'&&this.userInfo.adminFlag == 1){
       this.commonSave('ZT02', 'PARTNER_SYNCMDG');
    }else{
       this.returnPath();
    } */
                  this.returnPath();
                }
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch((err) => {
            console.log(err);
            if (err == 'baseData' || err == 'salesData' || err == 'purchasingData') {
              this.activeNameTab = err;
            } else {
              this.activeNameTab = 'baseData';
            }

            let message = this.$t('cooperation.message.topFormCheckResult');

            if (err == 'partnersBanks') {
              message = '请检查银行表格';
            } else if (err == 'partnersPersons') {
              message = '请检查联系人表格';
            } else if (err == 'receiveAddressTable') {
              message = '请检查收货地址表格';
            }
            toFormErrorTop();
            loading.endLoading();
            this.$message({
              showClose: true,
              message: message,
              type: 'error',
            });
          });
      },
      // 开启实时
      startTime() {
        // this.time = setInterval(()=>{
        this.topData.requestTime = dateTimeFormat(new Date(), true);
        // }, 1000)
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/masterData/editCooperation',
            name: 'editCooperation',
            meta: {
              keepAlive: true,
              title: this.$t('cooperation.route.addCooperation'),
            },
          },
          toPath: {
            path: '/masterData/cooperation',
            name: 'cooperation',
            meta: {
              keepAlive: false,
              title: this.$t('cooperation.route.cooperation'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },

      async initLocationData() {
        if (this.baseData.ifDomestic == this.$globalVar.CHNCode) {
          var res = await this.$axios.post(
            BASE_API.QUERY_PROVICE + '?parentAreaNo=' + this.$globalVar.CHNCode
          );
          if (res.data.code === 0) {
            this.provinceList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
          if (this.baseData.province && this.baseData.province.length > 0) {
            await this.handleProvinceChange(this.baseData.province, false);
          }
          if (this.baseData.city && this.baseData.city.length > 0) {
            this.handleCityChange(this.baseData.city);
          }
          return;
        }
      },

      //国家切换 => 获取省份
      changeCountry(value) {
        this.baseData.province = !value ? this.baseData.province : '';
        this.baseData.city = !value ? this.baseData.city : '';
        if (!value) this.changeProvince();
        value = value || this.baseData.ifDomestic;
        // if (this.baseData.ifDomestic == this.$globalVar.CHNCode && this.provinceListCN.length > 0) {
        //   this.provinceList = { ...this.provinceListCN };
        //   return;
        // }
        this.$axios.post(BASE_API.QUERY_PROVICE + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.provinceList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      async handleProvinceChange(val, clearCity = true) {
        if (val && val.length) {
          let name = this.provinceList.find((item) => item.value == val)?.label;
          if (name && name.length) {
            this.baseData.provinceName = name;
          }
          console.log('provinceChange', this.baseData.provinceName, this.baseData.province);
          if (clearCity) {
            this.baseData.city = null;
          }
          var res = await this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + val);
          if (res.data.code === 0) {
            this.cityList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
      },
      async handleCityChange(val) {
        if (val && val.length) {
          let name = this.cityList.find((item) => item.value == val)?.label;
          if (name && name.length) {
            this.baseData.cityName = name;
          }
          console.log('cityChange', this.baseData.cityName, this.baseData.city);
        }
      },
      // 省份切换 => 获取城市
      changeProvince(value) {
        this.baseData.city = !value ? this.baseData.city : '';
        value = value || this.baseData.province;
        this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.cityList = res.data.data;
            if (this.baseData.city && this.baseData.city.length > 0) {
              this.baseData.city = this.cityList.find(
                (item) => item.value == this.baseData.city
              ).label;
            }
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 改变校验规则
      changeRules(baseRules) {
        let result = { ...baseRules, ...deliverRules };

        let invoiceRequired = true;
        if (this.baseData.ifPersonalPartner == '1') {
          invoiceRequired = false;
        } else {
          if (this.baseData.taxType == '2') {
            invoiceRequired = false;
          }
        }
        //供应商HZHB02
        if (this.baseData.partnerType && this.baseData.partnerType == 'HZHB02') {
          invoiceRequired = false;
        }
        Object.keys(result).forEach((key) => {
          if (
            key == 'invoiceAddress' ||
            key == 'invoicePhone' ||
            key == 'invoiceBankName' ||
            key == 'invoiceBankAccount'
          ) {
            if (invoiceRequired) {
              result[key][0].required = true;
            } else {
              result[key][0].required = false;
            }
          }
        });

        this.rules = result;
        const componentsList = [
          'topData',
          'baseData',
          // 'salesData', 'purchasingData'
        ];
        this.$nextTick(() => {
          componentsList.forEach((item) => {
            this.$refs[item].clearValidate();
          });
        });
      },
      // 判断校验规则
      resolveRules(val, type) {
        const { ifDomestic, ifPersonalPartner } = this.baseData;
        let arr = ['HZHB01', 'HZHB10', 'HZHB03'];
        let flag = arr.find((item) => item == this.baseData.partnerType);
        if (type == 'ifDomestic') {
          this.changeCountry(val);
        }
        // if (ifDomestic == this.$globalVar.CHNCode) {
        //   if (ifPersonalPartner == 1) {
        //     this.changeRules(personalRules) // 国内个人校验规则
        //   } else {
        //     this.changeRules(domesticEnterprisesRules) // 国内企业校验规则
        //   }
        // } else {
        //   this.changeRules(foreignRules) // 国外校验规则
        // }

        if (ifPersonalPartner == 1) {
          this.baseData.creditCode = null;
        } else {
          this.baseData.identityNo = null;
        }
        if (ifDomestic == this.$globalVar.CHNCode) {
          if (ifPersonalPartner == 1 && !flag) {
            console.log('国内个人');
            //国内个人校验
            this.changeRules(personalRules);
          } else if (ifPersonalPartner != 1 && !flag) {
            //国内企业校验
            console.log('国内企业');
            this.changeRules(domesticEnterprisesRules);
          } else if (ifPersonalPartner == 1 && flag) {
            console.log('国内个人合作伙伴');
            //国内个人甲和合作伙伴
            this.changeRules(personalRulesParter);
          } else if (ifPersonalPartner != 1 && flag) {
            console.log('国内企业加合作伙伴');
            //国内企业加合作伙伴
            this.changeRules(domesticEnterprisesRulesParter);
          }
        } else {
          if (!flag) {
            if (ifPersonalPartner == 1) {
              this.changeRules(foreignRules); // 国外个人校验规则
            } else {
              this.changeRules(foreignRulesPerson); //国外企业
            }
          } else {
            if (ifPersonalPartner == 1) {
              this.changeRules(foreignRulesParter); // 国外校验规则+合作伙伴+个人
            } else {
              this.changeRules(foreignRulesParterPerson); // 国外校验规则+合作伙伴+企业
            }
          }
        }
      },
      // 根据合作伙伴类型判断销售、采购的检验状态
      // // resolveSellRules(value) {
      // //   if (value === 'HZHB01' || value === 'HZHB10') {
      // //     // 客户
      // //     this.sellSubjectRule = sellSubjectRule;
      // //     this.sellForbid = false;
      // //     this.purchaseSubjectRule = [];
      // //     this.purchaseForbid = true;
      // //     this.$refs.purchasingData.resetFields();
      // //   }
      // //   // else if (value === "HZHB02") { // 供应商
      // //   //   this.sellSubjectRule = [];
      // //   //   this.sellForbid = true;
      // //   //   this.$refs.salesData.resetFields();
      // //   //   this.purchaseSubjectRule = purchaseSubjectRule;
      // //   //   this.purchaseForbid = false;
      // //   // }
      // //   else if (value === 'HZHB03') {
      // //     // 合作伙伴
      // //     this.sellSubjectRule = sellSubjectRule;
      // //     this.sellForbid = false;
      // //     this.purchaseSubjectRule = purchaseSubjectRule;
      // //     this.purchaseForbid = false;
      // //   } else {
      // //     // 其他
      // //     // this.sellSubjectRule = sellSubjectRule;
      // //     // this.purchaseSubjectRule = [];
      // //     // this.sellForbid = false;
      // //     // this.purchaseForbid = false;
      // //     this.sellSubjectRule = [];
      // //     this.sellForbid = true;
      ////     //  // this.$refs.salesData.resetFields();
      // //     this.purchaseSubjectRule = purchaseSubjectRule;
      // //     this.purchaseForbid = false;
      // //   }
      // // },
      // 附件上传
      // handleUpload(uploadTableData) {
      //   this.baseData.partnersAttachments = uploadTableData;
      // },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },

      setCreateByName(id) {
        let _self = this;
        // 获取用户数据
        _self.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            _self.requestByList = res.data.data.personInfo;
            var obj = _self.requestByList.find((item) => {
              return item.id == id;
            });
            _self.topData.createBy = obj ? obj.personName : Number(id);
          }
        });
      },
      // 获取字典值
      getDictList() {
        const { tenantCode } = this.userInfo;
        // 获取部门数据
        this.$axios.post(API.GET_LIST_PERSON, { id: this.userInfo.userCode }).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          }
        });
        // 获取用户数据
        this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' }).then((res) => {
          if (res.data.code === 0) {
            this.requestByList = res.data.data.personInfo;
            var obj = this.requestByList.find((item) => {
              return item.id == this.topData.requestBy;
            });
            this.topData.requestByName = obj ? obj.personName : '';
          }
        });
        // 交易币种（币种管理）
        this.$baseRequest.getCurrency().then((res) => {
          this.tradeCurrencyList = [];
          if (res.length > 0) {
            res.map((item) => {
              item['value'] = item.currencyCode;
              item['label'] = item.currencyName;
              this.tradeCurrencyList.push(item);
            });
          }
        });
        // 状态
        this.$axios.post(API.DICT_LIST, { dictType: 'request_status', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.requestStatusList = res.data.data; // 下拉
            for (let item of this.requestStatusList) {
              // => 用于表格回显
              this.requestStatusData[item['value']] = item['label'];
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
        // // 对账科目
        // this.$baseRequest.getAccountListByCompanyCode(companyCode).then(res=>{
        //   this.subjectList = res;
        // })
        // // //销售数据对帐
        // // this.$axios
        // //   .post(API.DICT_LIST, { dictType: 'generalLedgerAccountSales', tenantCode: tenantCode })
        // //   .then((res) => {
        // //     if (res.data.code === 0) {
        // //       this.subjectList = res.data.data;
        // //     } else {
        // //       this.$message({ showClose: true, message: res.data.msg, type: 'error' });
        // //     }
        // //   });
        // // //采购数据对账
        // // this.$axios
        // //   .post(API.DICT_LIST, { dictType: 'generalLedgerAccountPurchase', tenantCode: tenantCode })
        // //   .then((res) => {
        // //     if (res.data.code === 0) {
        // //       this.subjectProcureList = res.data.data;
        // //     } else {
        // //       this.$message({ showClose: true, message: res.data.msg, type: 'error' });
        // //     }
        // //   });
      },
      // 销售数据对账科目变化
      // // sellReconciliationSubjectChange(value) {
      // //   if (value) {
      // //     this.salesData.sellReconciliationSubjectDesc = value;
      // //     this.$refs.salesData.clearValidate('sellReconciliationSubject');
      // //   } else {
      // //     this.salesData.sellReconciliationSubjectDesc = '';
      // //   }
      // // },
      // 采购数据对账科目变化
      // // procurementReconciliationSubjectChange(value) {
      // //   if (value) {
      // //     this.purchasingData.procurementReconciliationSubjectDesc = value;
      // //     this.$refs.purchasingData.clearValidate('procurementReconciliationSubject');
      // //   } else {
      // //     this.purchasingData.procurementReconciliationSubjectDesc = '';
      // //   }
      // // },
      // 状态切换
      handleEdit() {
        if (
          this.partnerDetail.requestStatus !== 'ZT02' &&
          this.partnerDetail.requestStatus !== 'ZT04' &&
          this.partnerDetail.requestStatus !== 'ZT07'
        ) {
          // 审批中和禁用状态不能修改
          this.forbidden = !this.forbidden;
          this.saveforbidden = !this.saveforbidden;
          // // this.resolveSellRules(this.partnerDetail.partnerType);
          if (this.forbidden) {
            // clearInterval(this.time); // 清除定时器
            this.editConfig = {};
            const formList = [
              'topData',

              'baseData',
              // ,
              // , 'salesData', 'purchasingData'
            ];
            formList.forEach((el) => {
              Object.keys(this[el]).forEach((item) => {
                this[el][item] = this.partnerDetail[item];
              });
            });
            this.topData.requestBy = Number(this.topData.requestBy);
            this.setCreateByName(this.topData.createBy);
          } else {
            this.startTime();
            this.editConfig = { trigger: 'click', mode: 'row' };
            // this.topData.companyCode = this.userInfo.companyCode;
            // this.topData.companyName = this.userInfo.companyName;
            // this.topData.departmentCode = this.userInfo.departmentCode;
            // this.topData.departmentName = this.userInfo.departmentName;
            // this.topData.requestBy = Number(this.topData.requestBy);
            // this.topData.createBy = Number(this.userInfo.userCode);
          }
        } else {
          // 草稿状态
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.canNotChange'),
            type: 'error',
          });
        }
        var arr = this.requestByList.filter((item) => item.id == this.topData.requestBy);
        this.topData.requestByName = arr.length > 0 ? arr[0].personName : '';
      },
      // 切换部门
      departmentChange(value) {
        let params = {
          departmentCode: value,
          partnerCode: this.partnerDetail.partnerCode,
        };
        this.$axios.post(API.LIST_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data.length > 0) {
              this.getDetail(value);
            } else {
              this.topData.departmentCode = this.partnerDetail.departmentCode; // 恢复部门代码
              this.$message({
                showClose: true,
                message: '该部门没有当前合作伙伴数据',
                type: 'error',
              });
            }
          }
        });
      },
      // 导出详情
      handleExport() {
        const params = {
          partnerCode: this.partnerDetail.partnerCode,
          departmentCode: this.partnerDetail.departmentCode,
          id: this.propsPartnerDetail.id,
        };
        console.log('params: ', params);
        this.$axios.post(API.EXPORT_PARTNERS_DETAIL, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 信用额度申请
      creditApply() {
        let path = {
          path: '/credit/applicationAdd',
          name: 'applicationCreditAdd',
          meta: {
            keepAlive: true,
          },
          query: this.partnerDetail,
        };
        delete path.query.id; //跳转信用额度去掉id
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 信用额度查看
      creditSee() {
        let path = {
          path: '/credit/creditList',
          name: 'creditList',
          meta: {
            keepAlive: true,
          },
          query: {
            partnerZhName: this.partnerDetail.partnerZhName,
            validDate: dateFormat(new Date()),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
<style lang="scss">
  .editCooperation .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }

  .editCooperation .textOver label {
    line-height: unset;
  }

  .editCooperation .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
<style scoped lang="scss">
  .topData {
    padding: 15px 0;
  }

  .editCooperation {
    padding-bottom: 100px;
  }

  /* 顶部按钮 */
  .editCooperation .btn {
    text-align: left;
    padding: 20px 0px;
  }

  .footer-bottom-list {
    justify-content: center;
    display: flex;
    padding-top: 20px;
  }

  .editCooperation .el-select,
  .el-input {
    width: 100%;
  }

  ::v-deep.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #000000;
  }

  ::v-deep.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #00b400;
  }

  .topData {
    padding: 15px 0;
  }

  .editCooperation {
    padding-bottom: 100px;
  }

  /* 顶部按钮 */
  .editCooperation .btn {
    text-align: left;
    padding: 20px 0px;
  }

  .editCooperation .btns {
    text-align: right;
    padding: 20px 0px;
  }

  .footer-bottom-list {
    justify-content: center;
    display: flex;
    padding-top: 20px;
  }

  .editCooperation .el-select,
  .el-input {
    width: 100%;
  }

  ::v-deep.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #000000;
  }

  ::v-deep.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #00b400;
  }

  .editCooperation .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }

  .editCooperation .textOver label {
    line-height: unset;
  }

  .editCooperation .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
